import { InstallationVariableType } from "../API";

export const hr = {
  isPromotionalEmailRecipient: "Primatelj promotivnih emailova",
  travelWarrantDeparturePeriod: "Razdoblje prema datumu polaska (uključivo)",
  travelWarrantAllDates: "Svi datumi",
  travelWarrantAccountBalance: "Stanje računa",
  travelWarrantAccountBalancePeriodNote: "Stanje prema knjigovodstvenoj evidenciji, ne ovisi o odabranom razdoblju polaska.",
  pantheon_docs: "Pantheon docs",
  "external-accounts": "Povezani računi",
  "mcp-api-keys": "MCP API ključevi",
  serialNumberDirectionIsInput: "Serijski brojevi se UNOSE",
  hideDocumentItemElements: "Sakrijte elemente stavaka",
  hideDocumentElements: "Sakrijt elemente dokumenta",
  ignoreQuantityInWholeDocument: "Ignoriraj svu količinu u cijelom dokumentu",
  searchSettings: "Pretraživanje postavki",
  rebates: "Rabati",
  agents: "Agenti",
  "support-group": "Grupa podrške",
  "support-groups": "Grupe podrške",
  "adding-support-group": "Dodavanje grupe podrške",
  "editing-support-group": "Uređivanje grupe podrške",
  "problem-submissions": "Problem submissioni",
  "add-member": "Dodaj člana",
  "no-members": "Nema članova",
  "select-support-group": "Odaberite grupu podrške",
  "no-support-groups-found": "Nema grupa podrške",
  useDeadlineDateOnOverview: "Prikaži rok za isporuku na pregledu dokumenata",
  isDisabled: "Deaktivirano",
  adminSerialNumbersAreNotAutomated: "Ručno izdavanje serijskih brojeva",
  adminShowSubjectAdd: "Prikaži dodavanje subjekata",
  recommendToMakeCodebooksOffline: "Prikaži OFFLINE preuzimanje šifarnika",
  isRetail: "Maloprodaja",
  documentTopAdditionalText: "Dodatni tekst na vrhu POS dokumenta",
  isActive: "Aktivan",
  sql_editor: "SQL zadaci",
  sql_templates: "SQL predlošci",
  sql_objects: "Objekti baze",
  sql_tables: "Tablice",
  sql_views: "Viewovi",
  sql_procedures: "Procedure",
  sql_functions: "Funkcije",
  sql_triggers: "Okidači",
  sql_other_objects: "Ostali objekti",
  sql_synonyms: "Sinonimi",
  sql_sequences: "Sekvence",
  sql_types: "Tipovi",
  sql_schemas: "Sheme",
  sql_roles: "Uloge",
  sql_columns: "Stupci",
  sql_constraints: "Ograničenja",
  sql_indexes: "Indeksi",
  sql_parameters: "Parametri",
  sql_dependencies: "Ovisnosti",
  sql_memberships: "Članstva",
  sql_permissions: "Dozvole",
  sql_object: "Objekt",
  sql_parent: "Nadređeni objekt",
  sql_object_type: "Vrsta",
  sql_details: "Detalji",
  sql_disabled: "Onemogućeno",
  sql_object_details_loading: "Učitavanje detalja objekta...",
  sql_object_details_empty: "Odabrani objekt nema dostupnih detalja.",
  sql_object_details_load_failed: "Učitavanje detalja objekta nije uspjelo",
  sql_users: "Korisnici",
  sql_sessions: "Sesije",
  sql_apply_template: "Primijeni predložak",
  sql_metadata_connection_missing:
    "Odaberite poduzeće ili unesite connection string kako biste učitali objekte baze.",
  sql_template_name: "Naziv",
  sql_template_category: "Kategorija",
  sql_template_description: "Opis",
  sql_template_pinned: "Pin",
  schema_name: "Shema",
  table_name: "Tablica",
  view_name: "View",
  routine_name: "Naziv rutine",
  routine_type: "Tip rutine",
  user_name: "Korisnik",
  user_type: "Vrsta",
  authentication_type: "Autentikacija",
  default_schema: "Zadana shema",
  session_id: "Sesija",
  login_name: "Prijava",
  host_name: "Računalo",
  program_name: "Program",
  command: "Naredba",
  login_time: "Vrijeme prijave",
  cpu_time_ms: "CPU (ms)",
  total_elapsed_time_ms: "Ukupno vrijeme (ms)",
  blocking_session_id: "Blokirajuća sesija",
  row_count: "Broj redaka",
  created_on: "Kreirano",
  modified_on: "Zadnja promjena",
  "codemagic-artifacts": "CodeMagic artefakti",
  quantityDecimalPlaces: "Decimalna mjesta količine",
  applicationUserId: "Korisnik",
  articleSearchShowOnlyWhereAcSetOfItemIs: "Prikaži samo gdje je AcSetOfItem",
  releaseNotes: "Bilješke",
  domain: "Domena",
  "active-releases": "Aktivne objave",
  hideWarehouseOverview: "Sakrij pregled skladišta",
  adminDefaultAcPriceRate: "Zadani AcPriceRate",
  "all-releases": "Sve objave",
  editRelease: "Uređivanje objave",
  showDeliveryDeadlineDays: "Prikaži unos za rok isporuke",
  showDeliveryMethod: "Prikaži unos načina isporuke",
  showModifierCharacterPicker: "Prikaži odabir dodatnog filtera",
  modifierCharacterLabel: "Naziv dodatnog filtera",
  showPaymentMethod: "Prikaži unos načina plaćanja",
  addRelease: "Dodavanje objave",
  releaseDate: "Datum objave",
  requireASignature: "Obavezno potpisivanje dokumenta",
  releases: "Mobilne verzije",
  scheduler: "Planer",
  newNewDocumentInputType: "Novi tip unosa dokumenta (EKSPERIMENTALNO)",
  lastChecked: "Zadnja provjera",
  acPrsn3: "Kupac",
  mustFiscalize: "Obavezno fiskalizirati",
  sendB2BAsEInvoice: "Šalji domaće B2B eRačune (F2)",
  anSalePrice: "Maloprodajna cijena",
  anRtprice: "VP cijena",
  documentOnCreateMakePDF: "Napravi PDF dokument prilikom kreiranja",
  useSquareArticlePicker: "Koristi kvadratni izbornik artikala",
  anWsprice2: "VP cijena 2",
  acSubject: "Subjekt",
  acName2: "Naziv",
  acPost: "Pošta",
  acPhone: "Telefon",
  "list-items": "Stavke",
  "detailed-search": "Detaljno pretraživanje",
  anRebate: "Popust",
  articleDontShowPriceAnyWhere: "Ne prikazuj cijenu nigdje",
  articleDontShowStockAnyWhere: "Ne prikazuj stanje na skladištu nigdje",
  jumpToEditAfterScanningItemWithBarcode:
    "Idi na uređivanje nakon skeniranja artikla sa barkodom",
  anRebate3: "R3",
  disallowChangingCustomer: "Onemogući promjenu kupca",
  disallowPickingCustomer: "Onemogući odabir kupca",
  defaultToThisCustomer: "Zadani kupac",
  defaultPaymentMethod: "Zadani način plaćanja",
  filterByAcDelivery:
    "Prikaži filter po AcDelivery (ovo se odnosi na AcDelivery postavljen na korisniku)",
  filterByAcVerifiedPrices: "Filtriraj po AcVerifiedPrices",
  filterByAcVerifyStatus: "Filtriraj po AcVerifyStatus",
  filterByAcDept: "Filtriraj po AcDept",
  showAcDeptMobileFilterOnDocumentList:
    "Prikaži AcDept filter na listi dokumenata",
  showAcDeliveryMobileFilterOnDocumentList:
    "Prikaži AcDelivery filter na listi dokumenata",
  acStatusIn: "Prikaži samo dokumente s AcStatus",
  showAllDocumentsNotOnlyAnUserIns:
    "Prikaži sve dokumente, ne samo one koji su kreirani od strane prijavljenog korisnika",
  historyViewIgnoredFilters:
    "Filteri koje ignoriramo u povijesnom pregledu (npr: filterByAcDelivery,filterByAcDept)",
  filterByAcType: "Filtriraj po AcType",
  printTicketNameOverride: "Koji ispis koristiti za POS printer",
  filterReceiversByAcFieldSa: "Filtriraj primatelje po AcFieldSa",
  warehousePositionTHeSetItemFieldName:
    "Naziv polja u koje se upisuje pozicija u skladištu",
  warehouseShowPrices: "Prikaži cijene na skladištu",
  documentNote:
    "Naziv za ovu vrstu dokumenta (ono što se prikazuje u meniju i u naslovima)",
  hideWorkOrderReception: "Sakrij prijem",
  hideWorkOrderSpecications: "Sakrij specifikaciju",
  hideWorkOrderServices: "Sakrij usluge",
  hideWorkOrderMaterials: "Sakrij materijale",
  hideWorkOrderReclamations: "Sakrij reklamacije",
  hideWorkOrderImages: "Sakrij slike",
  hideWorkOrderPlaceFromTo: "Sakrij unos mjesta od-do",
  workOrderSpecificationTimeNotRequired: "Vrijeme specifikacije nije obavezno",
  workOrderSpecificationPrefillTime:
    "Popuni vrijeme u specifikaciji sa krajem prethodne specifikacije",
  anRebate2: "R2",
  manualWorkOrderMaterial: "Zamjenski materijal",
  workOrderCanBeUnlocked: "Radni nalog može biti otključan",
  workOrderUnlockableStatus: "Status iz kojeg se radni nalog smije otključati (prazno = nije dopušteno)",
  acFieldSFLabel:
    "Labela za AcFieldSF proizvoljno polje (KOMPAKT koristi za ticket)",
  enabled: "Omogućeno",
  server: "Poslužitelj",
  database: "Baza",
  error: "Greška",
  up: "Dostupno",
  "editing-remote-connection": "Uređivanje vanjskog spajanja",
  "adding-remote-connection": "Dodavanje vanjskog spajanja",
  "remote-connections": "Vanjska spajanja",
  remote_connections: "Vanjska spajanja",
  "Pick a currecy": "Odaberite valutu",
  anVat: "PDV",
  discount: "Rabat",
  valueWithDiscount: "Vrijednost",
  acNote: "Napomena",
  anRebate1: "R1",
  documentDate: "Datum dokumenta",
  anNo: "R. br.",
  acIdent: "Šifra",
  acName: "Naziv",
  anQty: "Količina",
  acUm: "JM",
  anPrice: "Cijena",
  anPvvalue: "Vrijednost",
  anPvvat: "PDV",
  anPvforPay: "Za platiti",
  anForPay: "Za platiti",
  acReceiver: "Primatelj",
  acConsignee: "Kupac",
  acDept: "Odjel",
  adDate: "Datum",
  acKey: "Ključ",
  list: "Lista",
  "web-documents": "Dokumenti",
  "web-documents-order": "Dokumenti",
  "web-documents-move": "Dokumenti",
  new: "Novi",
  kanban: "Organizacija",
  AssignPhoneNumberToContact: "Poveži broj telefona s kontaktom",
  calls: "Pozivi",
  "no-phone-sessions": "Nema poziva",
  "total-time-on-phone": "Ukupno vrijeme na telefonu",
  phoneNumber: "Broj telefona",
  "adding-new-phone-number": "Dodavanje novog broja telefona",
  "editing-phone-number": "Uređivanje broja telefona",
  "phone-numbers": "Brojevi telefona",
  cisco_phone_sessions: "Pozivi",
  "refresh-message": "Osvježi poruku",
  lastRequestSource: "Zadnji izvor",
  deselect: "Odznači sve",
  NotRequired: "Nije potrebno",
  Required: "Potrebno",
  None: " - ",
  Yes: "Da",
  No: "Ne",
  companyStamp: "Pečat poduzeća",
  pantheonSubjects: "Pantheon subjekti",
  "onix-phone-login-qrcode": "QR kod",
  onix_phone_login: "QR kod",
  workOrderItemsAdditionalReportData: "Zapisnik na prijemu radnog naloga",
  WorkOrderItemsAdditionalReportDataEditor: "Zapisnik na prijemu radnog naloga",
  "field-type": "Tip polja",
  "onix-phone-report-data-json-editor": "Onix Phone report data JSON editor",
  workerFirstName: "Ime radnika",
  workerLastName: "Prezime radnika",
  onix_phone_documents: "Pregled",
  "marservis-work-order-items": "Poslovi radnog naloga",
  "marservis-work-order-item-works": "Odrađeni radovi posla",
  "work-order-item": "Posao",
  "work-order-item-works": "Radovi posla",
  "work-order-attachments": "Prilozi radnog naloga",
  userNotes: "Korisničke bilješke",
  marservis_workorders_ending_soon:
    "Radni nalozi koji završavaju unutar 5 dana",
  totalWorkTime: "Ukupno vrijeme rada",
  workOrderDate: "Datum radnog naloga",
  itemName: "Artikl",
  projectName: "Projekt",
  subjectName: "Subjekt",
  documentNumber: "Broj dokumenta",
  workDate: "Datum rada",
  work_orders_overview: "Pregled",
  Warehouse: "Skladište",
  List: "Pregled dokumenata",
  UnfinishedDocuments: "Nedovršeni dokumenti",
  FIXED_ASSETS: "Osnovna sredstva",
  MARSERVIS_USER_WORK_ORDERS: "Radni nalozi",
  Inventory: "Inventura",
  WarehouseReceipt: "Primka",
  forceShowAvailableOnStock: "U pregledu obavezno prikaži dostupno",
  "work-attachments": "Prilozi poslova",
  "writing-response-internal-communication": "Nova interna poruka",
  "add-internal-communication": "Dodaj internu poruku",
  "users-with-access": "Kontrola pristupa",
  forBilling: "Za naplatu",
  "work-hours": "Sati rada",
  FixedAssets: "Osnovna sredstva",
  skipConfirmationOnShortcuts:
    "Skoči direktno na izradu krajnjeg dokumenta (umjesto prikaza detalja izvornog dokumenta)",
  pickingShowConfirmationOnPick:
    "Prikaži poruku da je dostignuta potrebna količina",
  healthchecks_dashboard: "Healthchecks",
  transformation: "Transformacija",
  fromId: "Od",
  toId: "Na",
  WorkOrdersReception: "Radni nalozi - prijem",
  WorkOrdersOperative: "Radni nalozi - operativa",
  Orders: "Narudžbe",
  Approvals: "Odobrenje",
  DeliveryNotesControl: "Kontrola otpremnice",
  DeliveryNotesFromOrder: "Otpremnica iz narudžbe",
  InvoiceDeliveryNotes: "Račun iz otpremnice",
  LURInvoice: "Račun - Lučka uprava rovinj",
  MarservisUserWorkOrders: "Korisnički radni nalozi - Marservis",
  acWorkPlace: "Radno mj.",
  acFiscalDevice: "Fiskalni ur.",
  Copy: "Kopiranje",
  DeliveryNotes: "Otpremnice",
  wiki_local: "Lokalni wiki",
  wiki: "Wiki",
  "delete-support-todo": "obrisati ovaj podsjetnik?",
  "no-team-viewer-sessions": "Nema TeamViewer sesija",
  "total-time-on-teamviewer": "Ukupno vrijeme TeamViewer",
  "delete-support-time-log": "obrisati ovo vrijeme rada?",
  todos: "Podsjetnici",
  duration: "Trajanje",
  startDate: "Početak",
  endDate: "Kraj",
  deviceName: "Naziv uređaja",
  deviceId: "ID uređaja",
  supportTicketTimeLogId: "Vrijeme rada",
  supportTicketId: "Tiket",
  update: "Ažuriraj",
  "want-to-close-without-billable-time-log-or-unassigned-team-viewer-sessions":
    "nastaviti bez naplativog vremena rada ili s TeamViewer sesijama koje nemaju povezano vrijeme rada?",
  "want-to-close-with-unassigned-team-viewer-sessions":
    "Želite li nastaviti s TeamViewer sesijama koje nemaju vrijeme rada?",
  "editing-team-viewer-session": "Editing TeamViewer session",
  "adding-new-team-viewer-session": "Adding TeamViewer session",
  team_viewer_sessions: "TeamViewer spajanja",
  "expense-bearer-changed-since-adding-to-this-document":
    "Podaci na nositelju troška su se promjenili, kliknite ovdje ako želite preračunati dnevnice i tečaj.",
  adminUseAnWsPrice: "Koristi AnWsPrice prije ostalih",
  adminShowDailyIncome: "Prikaži zaključak blagajne",
  articleSearchAllowSearchingByClassification:
    "Prikaži filter po klasifikaciji prije liste idenata",
  adminUseGenericDocumentsForMoveAndOrder:
    "Koristi generičku izradu dokumenata za THeMove i THeOrder",
  adminSendDocumentToCompanyDocumentEmail:
    "Šalji sažetak dokumenta na Email poduzeća",
  adminIgnoreRebate1: "Ne koristi rabat 1",
  adminIgnoreRebate2: "Ne koristi rabat 2",
  adminIgnoreRebate3: "Ne koristi rabat 3",
  "department-items": "Artikli odjela",
  workOrder: "Radni nalog",
  "automatic-logout": "Automatska odjava",
  system: "Sustav",
  "general-settings": "Opće postavke",
  workOrderStatus: "Status radnog naloga",
  "mark-as-not-finished": "Označi kao neodrađeno",
  WorkOrderInitials: "RN",
  "Ne postoji ova veza artikla i grupe": "Ne postoji ova veza artikla i grupe",
  "item-groups": "Grupe artikla",
  adminEmphasizeInStock: "Istakni artikle koji su na skladištu",
  groupAllDocumentTypesAtThisPoint:
    "Grupiraj sve tipove dokumenata na ovom mjestu (ovo znači da će sve VD iz kojih se radi ovaj dokument biti grupirane u jedan pregled, jedan odabir ako je kopiranje i slično)",
  groupAllCreatingDocumentTypesAtThisPoint:
    "Grupiraj sve tipove dokumenata za izradu na ovom mjestu (ne koristi se)",
  "add-to-customer": "Dodaj kupcu",
  "connect-project": "Poveži projekt",
  "The DateEnd field is required.": "Odaberite datum kraja",
  "The ProjectId field is required.": "Odaberite projekt",
  "The UserId field is required.": "Odaberite radnika",
  "The ItemId field is required.": "Odaberite artikl",
  transmissionSerialNumber: "Serijski broj mjenjača",
  engineSerialNumber: "Serijski broj motora",
  hinNumber: "HIN broj",
  "mark-as-finished": "Označi kao odrađeno",
  InProgress: "U radu",
  "total-hours": "Ukupno sati",
  "department-overview": "Odjel",
  "connect-item": "Poveži artikl",
  "add-to-group": "Dodaj u grupu",
  "item-group-overview": "Grupa",
  billableTime: "Sati za naplatu",
  "work-order-open": "Radni nalog otvoren",
  workOrderId: "ID radnog naloga",
  itemGroupName: "Grupa",
  itemGroup: "Grupa",
  "new-entry": "Novi zapis",
  "without-group": "Bez grupe",
  "picking-article-group": "Odabir grupe",
  "add-all-items-from-group": "Dodaj artikle iz grupe",
  hasAccess: "Pristup",
  "adding-user-to-file-permissions": "Dodavanje korisnika",
  "you-want-to-delete-this-file": "obrisati ovu datoteku?",
  permissions: "Dozvole",
  "date-changed-do-you-want-to-recalculate-down-payment-conversion":
    "Želite li rekalkulirati tečaj predujma da odgovara odabranom datumu?",
  experiments: "Eksperimenti",
  "download-pdf": "Preuzmi PDF",
  "open-pdf": "Otvori PDF",
  creating: "Izrađivanje",
  updating: "Ažuriranje",
  reading: "Čitanje",
  deactivated: "Deaktiviran",
  "A task must have responsible agent": "Zadatak mora imati odgovornog agenta",
  "task-start-date": "Početak zadatka",
  "task-end-date": "Kraj zadatka",
  deleting: "Brisanje",
  uploading: "Slanje",
  saving: "Spremanje",
  "there-was-an-error": "Došlo je do greške",
  "try-again": "Pokušajte ponovno",
  "drop-files-for-upload": "Ispustite datoteke za prijenos",
  "drop-some-files-or-click-to-select":
    "Ovdje povucite neke datoteke ili kliknite da biste ih odabrali",
  "adding-file": "Dodavanje privitka",
  "editing-file": "Uređivanje privitka",
  "document-details": "Detalji dokumenta",
  "delete-document": "obrisati dokument?",
  itemGroupId: "Grupa artikla",
  departmentId: "Odjel artikla",
  Hangfire: "Hangfire",
  Swagger: "Swagger",
  GraphQL: "GraphQL",
  department: "Odjel",
  "item-group": "Grupa artikla",
  "editing-item-group": "Uređivanje grupe artikala",
  "adding-item-group": "Dodavanje grupe artikala",
  "adding-department": "Dodavanje odjela",
  "editing-department": "Uređivanje odjela",
  "server-downtimes": "Server downtime",
  "do-you-want-to-apply-new-conversion-for-currency":
    "Želite li postaviti novi tečaj za dnevnice? Iz {conversionFrom} {currency} u {conversionTo} {currency}",
  "codebooks-departments": "Odjeli",
  "codebooks-item-groups": "Grupe artikala",
  item_groups: "Grupe artikala",
  departments: "Odjeli",
  OpenTasks: "Otvoreni zadaci",
  "save-and-close": "Spremi i zatvori",
  "save-and-set-status": 'Spremi i stavi "{{status}}"',
  model: "Model",
  engineModel: "Motor",
  transmissionModel: "Model mjenjača",
  "adding-sql-template": "Dodavanje SQL predloška",
  "editing-sql-template": "Uređivanje SQL predloška",
  editing_packet: "Uređivanje paketa",
  firstName: "Ime",
  lastName: "Prezime",
  userName: "Korisničko ime",
  companySettingsId: "Poduzeće",
  companySettings: "Poduzeće",
  ForReview: "Pregledati",
  "undock-sidebar": "Odvoji bočnu traku",
  "dock-sidebar": "Fiksiraj bočnu traku",
  "spam-emails": "Spam mailovi",
  "adding-spam-email": "Dodavanje spam email-a",
  "editing-spam-email": "Uređivanje spam email-a",
  "save-task": "Spremi zadatak",
  "add-task": "Dodaj zadatak",
  "writing-response-task": "Dodavanje zadatka",
  grouping: "Grupiranje",
  attachments: "Prilozi",
  "grouping-settings-notice":
    'Grupiranje se primijenjuje samo na prikazane stavke, za grupiranje svih stavaka koristite gumb "Prikaži sve stavke".',
  "show-paginated": "Prikaži po stranicama",
  "show-all-items": "Prikaži sve stavke",
  "rest-of-the-groups": "Preostale grupe",
  pantheonId: "Pantheon ID",
  "active-groups": "Aktivne grupe",
  groups: "Grupe",
  "grouping-settings": "Postavke grupiranja",
  "toggle-status": "Promijeni status",
  Done: "Odrađeno",
  NotDone: "Nije odrađeno",
  Invoiced: "Fakturirano",
  temporaryOwner: "Agent",
  expenseBearer: "Nositelj troška",
  true: "Da",
  false: "Ne",
  isDone: "Završeno",
  all: "Sve",
  applicationUser: "Radnik",
  Users: "Korisnici",
  Workers: "Radnici",
  Contacts: "Kontakti",
  Projects: "Projekti",
  CompanySettings: "Baze",
  TicketMessages: "Poruke tiketa",
  Tickets: "Tiketi",
  Companies: "Poduzeća",
  "id-or-pantheonid": "Web ili Pantheon ID",
  "money-accounts": "Računi novca",
  "customer-accounts": "Računi kupca",
  "supplier-accounts": "Računi dobavljača",
  "add-account": "Dodavanje računa",
  "edit-account": "Uređivanje računa",
  "are-you-sure-you-want-to-delete":
    "Jeste li sigurni da želite obrisati '{0}'?",
  "business-analysis-accounts": "Računi",
  account: "Račun",
  "business-analysis-settings": "Postavke analize",
  "add-money-account": "Dodavanje računa novca",
  "edit-money-account": "Uređivanje računa novca",
  pantheon_key: "Pantheon ključ",
  onix_key: "Onix ključ",
  synchronized: "Sinkronizirano",
  not_synchronized: "Nije sinkronizirano",
  workerId: "Id radnika",
  pantheonWorker: "Pantheon radnik",
  costType: "Vrsta troška",
  downloads: "Preuzimanja",
  "adding-new-company-document": "Dodavanje dokumenta za poduzeće",
  "editing-company-document": "Uređivanje dokumenta poduzeća",
  fileId: "Dokument",
  reverseItemsList:
    "Obrnuti redoslijed stavki (zgodno kod inventura i ostalog gdje se skenira)",
  customer: "Kupac",
  warehouseOverviewShowOnlyInStock: "Prikaži samo dostupno (Pregled skladišta)",
  showAllItemsIgnoringWarehouse:
    "Prikaži cijeli THe_SetItem (Pregled i pretraživanje, ako je skladište postaljveno i dalje će se stanje prikazivati samo za to skladište)",
  articleSearchShowOnlyInStock:
    "Prikaži samo dostupno (Pretraživanje artikala)",
  articleSearchInitiallyLoadAll: "Učitaj sve kod otvaranja",
  articleSearchRepeatLastSearch: "Ponovi prethodno pretraživanje",
  itemListShowDetailed: "Prikaži više detalja",
  documentOnCreateMakePdf: "Izradi PDF novog dokumenta",
  documentOnCreateMakeBluetoothPrint:
    "Ispiši novi dokument na Bluetooth printer ",
  stockViewLoadAllOnOpen: "Učitaj sve kod otvaranja",
  stockViewShowOnlyInStock: "Prikaži samo dostupno (Pregled skladišta)",
  addingItemWarnIfQuantityMoreThanAvailable:
    "Upozori ako je količina veća od dostupne",
  bluetoothPrintCopiesNumber: "Broj kopija",
  cacheDuration: "Trajanje (min)",
  cacheUseCacheForAnyResource: "Predmemorija za sve resurse",
  cacheUseForArticleSearch: "Za artikle",
  cacheUseForCustomerSearch: "Za kupce",
  cacheUseForWarehouseSearch: "Za skladište",
  adminDocumentOnCreateMakeWarehouseReservation:
    "Izradi rezervaciju na skladištu",
  adminAllowChangingItemPrice: "Dopusti promijenu cijene",
  adminItemQuantityMustBeInStock: "Količina ne smije biti veća od dostupne",
  adminCanEditDocumentAfterSaving: "Omogući uređivanje nakon spremanja",
  adminDeleteItemsAfterDocumentIsSaved:
    "Omogući brisanje stavaka nakon spremanja",
  adminUseSerialNumberForItems: "Koristi serijske brojeve za stavke",
  "bluetooth-printer": "Bluetooth printer",
  document: "Dokument",
  items: "Artikli",
  "adding-items": "Dodavanje stavki",
  addingItems: "Dodavanje stavki",
  "codebooks-items": "Artikli",
  "adding-item": "Dodavanje artikla",
  "editing-item": "Uređivanje artikla",
  materials: "Materijali",
  "marservis-user-work-orders": "Radni nalozi",
  jobs: "Poslovi",
  "adding-work-order-job": "Dodavanje posla",
  "editing-work-order-job": "Uređivanje posla",
  itemId: "Artikl",

  "admin-settings": "Administratorske postavke",
  warehouseName: "Skladište",
  functionality: "Funkcionalnost",
  "users-old-and-new-notice":
    "Korisnici staro i korisnici novo koriste iste korisnike ali su postavke na razini korisnika drukčije, korisnici staro vrijedi za Onix Phone < 9.1.1",
  "users-old": "Korisnici staro",
  "users-new": "Korisnici novo",
  "admin-users-v2": "Korisnici novo",
  "want-to-delete-item": "obrisati stavku?",
  "contact-has-no-companies": "Kontakt nema povezanih poduzeća",
  "saved-filters": "Spremljeni filteri",
  "apply-filter": "Primijeni filter",
  "created-on-date": "Datum izrade",
  "modified-on-date": "Datum promjene",
  "due-date": "Datum kraja",
  travel_warrants_tutorial_company_settings:
    "Klikom na 'Postavke' možete uređivati postavke poduzeća i pokrenuti sinkronizaciju podataka prema i od vaše Pantheon baze podataka.",
  "Pantheon AcConfrm is not 'T' and AcStatus is not 'Otvoren'":
    "Pantheon 'AcConfrm' nije 'T' ili AcStatus nije 'Otvoren'.",
  WorkRecords: "Evidencija rada",
  TravelWarrants: "Putni nalozi",
  UserSynchronization: "Sinkronizacija korisnika",
  BusinessAnalytics: "Analiza",
  DuplicateUserName: "Korisničko ime već postoji",
  InvalidUserName:
    "Upišite ispravno korisničko ime bez diakritika, možete koristiti slova, brojeve i znakove -._@+",
  "The Password field is required.": "Polje lozinka je obavezno",
  logout: "Odjava",
  language: "Jezik",
  exit: "Izlaz",
  dateDue: "Kraj",
  return_to_main_user: "Povratak na glavnog korisnika",
  "this-page-has-multiple-tutorials": "Ova stranica ima više uputa",
  user_settings: "Korisničke postavke",
  warning: "Upozorenje",
  "not-selected": "Nije odabrano",
  cancel: "Odustani",
  activate: "Aktiviraj",
  deactivate: "Deaktiviraj",
  "pick-tutorial-to-get-started": "Odaberite jedne upute za početak",
  are_you_sure_you_want_to: "Jeste li sigurni da želite",
  user: "Korisnik",
  editing_work_hours: "Uređivanje sati rada",
  adding_work_hours: "Dodavanje sati rada",
  hours: "Sati",
  minutes: "Minute",
  note: "Napomena",
  save: "Spremi",
  delete: "Obriši",
  enter_valid_integer: "Unesite ispravan cijeli broj",
  editing_work_record: "Uređivanje evidencije rada",
  adding_work_record: "Dodavanje evidencije rada",
  today: "Danas",
  reload: "Osvježi",
  "date-from": "Od datuma",
  "date-to": "Do datuma",
  cost_bearer: "Nositelj troška",
  costBearer: "Nositelj troška",
  costBearerName: "Naziv nositelja troška",
  cost_type_options: "Vrsta zarade",
  cost_type: "Vrsta troška",
  workRecordCostType: "Vrsta troška",
  pantheonCostType: "Pantheon vrsta troška",
  pantheonCostGroup: "Pantheon grupa troška",
  pantheonCostGroupName: "Pantheon naziv grupe troška",
  day: "Dan",
  workHours: "Sati rada",
  workMinutes: "Minute rada",
  this_user_id_deactivated: "Ovaj korisnik je deaktiviran",
  users: "Korisnici",
  administration: "Administracija",
  companies: "Poduzeća",
  activity_reports: "Aktivnost",
  workers: "Radnici",
  settings: "Postavke",
  work_records: "Evidencija rada",
  overview: "Pregled",
  finalizing: "Zaključak",
  transfer: "Prijenos",
  analysis: "Analiza",
  company: "Poduzeće",
  applications: "Aplikacije",
  manual: "Uputstva",
  end: "Kraj",
  next: "Sljedeće",
  finish_manual: "Prekini upustva",
  while_manual_is_open_test_data_is_shown:
    "Dok su otvorena uputstva prikazuju se testni podaci",
  tutorial_work_records_date_picker:
    "Odaberite godinu i period za koji želite vidjeti podatke",
  tutorial_work_records_table:
    "Ovdje se prikazuju podaci za odabrani period, dupli klik na redak otvara formu za uređivanje.",
  tutorial_work_records_add_row:
    "Klikom na 'Dodaj' otvara se forma za unos retka. Redak predstavlja period i ima nositelja i vrstu troška.",
  tutorial_work_records_first_day:
    "Klikom na bilo koju čeliju u retku otvara se forma za dodavanje ili uređivanje broja radnih sati na taj dan.",
  tutorial_user_top_bar:
    "U ovom padajućem izborniku možete se odjaviti ili podesiti Vaše osnovne korisničke postavke",
  tutorial_manual_end:
    "Klikom na 'Uputstva' uvijek možete ponovno pokrenuti uputstva za stranicu na kojoj se nalazite.",
  tutorial_tenant_users:
    'Kao administrator, korisnike svog poduzeća možete pogledati klikom na "Radnici"',
  tutorial_work_records_overview:
    "Ovdje možete vidjeti unesenu evidenciju rada po nositelju, vrsti troška i radniku",
  tutorial_work_records_finalize:
    "Za zaključivanje i otključivanje perioda kliknite na zaključak",
  tutorial_work_records_upload:
    'Za prijenos podataka u Pantheon, odaberite "Prijenos"',
  tutorial_work_records_application:
    'Za dodavanje i uređivanje evidencije rada kliknite na "Evidencija rada"',
  tutorial_company_settings:
    "Vrste troška i sinkronizacija podataka(radnici/nositelji troška) nalaze se pod postavkama poduzeća",
  tutorial_company_settings_cost_types:
    "Ovdje možete vidjeti vrste troška koje Vi i Vaši korisnici možete koristiti kod dodavanja evidencije rada. \n Naziv vrste troška prikazivati će se kod dodavanja evidencije. Samo aktivne vrste troška prikazuju se kod dodavanja. \n Vrstu zarade birate kod uređivanja vrste troška, vrste zarade povučene su iz vašeg Pantheon programa. \n Duplim klikom na redak otvara se forma za uređivanje.",
  tutorial_work_records_tenant_data_sync:
    "Neke podatke potrebno je sinkronizirati s Vaše baze podataka na našu. Ova provjera pokreće se periodički i ne bi je trebalo pokretati ručno. Ako promjene želite vidjeti prije sljedeće automatske sinkronizacije kliknite na 'Pokreni sinkronizaciju'. Podaci koji se sinkroniziraju su korisnici i nositelji troška.",
  tutorial_work_records_overview_results:
    "U pregledu evidencije rada nalazi se prikaz po nositelju, vrsti troška i radniku. Prikaz možete filtrirati po radniku, vrsti troška, nositelju ili periodu.",
  work_records_overview: "Pregled evidencije rada",
  work_records_upload: "Prijenos evidencije rada",
  tutorial_work_records_finalize_date:
    "Za odabir perioda za zaključivanje koristite ovaj kalendar",
  tutorial_work_records_finalize_users:
    "Ovdje će se prikazivati korisnici za koje postoji evidencija rada za odabrani period. Možete zaključiti podatke cijelog perioda klikom na 'Zaključi sve'. Klikom na radnika možete zaključiti samo njegove podatke. Za otključavanje ponovno kliknite na radnika ili 'Otključaj sve'.",
  tutorial_work_records_finalize_finalized:
    "Ovako su prikazani radnici čiji su podaci zaključeni za odabrani period. Klikom na radnika mijenjate stanje podataka korisnika između zaključenog i otključanog.",
  tutorial_work_records_upload_date:
    "Koristite kalendar za odabir perioda čije podatke želite prenijeti u Vaš Pantheon sustav.",
  tutorial_work_records_upload_users:
    "Ovdje se prikazuju korisnici koji imaju podatke za odabrani period.",
  tutorial_work_records_upload_already_uploaded:
    "Ako već postoje prijenosi prikazati će Vam se ova poruka. Radnike koji su već preneseni nije moguće odabrati za ponovni prijenos.",
  tutorial_work_records_upload_checked_for_upload:
    "Klikom na korisnika označite ga za prijenos ili kliknite na gumb za prijenos 'Preostalih radnika'. Moguće je odabrati samo korisnike koji su svoje podatke poslali na zaključivanje.",
  tutorial_work_records_closed_period:
    "Ako je period zaključan prikazati će se ova poruka. Kao administrator možete kliknuti na nju za brzo otključavanje perioda.",
  tutorial_as_admin_user_picker:
    "Kao administrator, ovdje možete odabrati korisnika za kojeg želite uređivati podatke. ",
  overview_by_cost_bearer: "Pregled po nositelju",
  overview_by_cost_type: "Pregled po vrsti troška",
  overview_by_worker: "Pregled po radniku",
  homepage: "Početna",
  tutorial_work_records_overview_by_cost_bearer:
    "Ovdje će se prikazivati rezultati vaše pretrage grupirani po nositelju, vrsti troška i radnicima.",
  tutorial_work_records_overview_results_workers:
    "U pregledu po vrsti trokška možete vidjeti ukupno utrošeno vrijeme po vrsti troška.",
  tutorial_work_records_overview_workers:
    "U pregledu po radnicima možete vidjeti detaljan prikaz evidencije za svakog radnika u periodu.",
  tutorial_work_records_overview_workers_edit:
    "Klikom na ikonu pored radnika otvara se aplikacijski prikaz evidencije rada u kojem možete uređivati prikazane podatke.",
  tutorial_work_records_overview_locked:
    "Ovako su prikazani zaključani periodi",
  tutorial_work_records_dashboard:
    'Za dodavanje i uređivanje evidencije rada kliknite na "Evidencija rada"',
  tutorial_work_records_closed_period_user:
    "Ako je period zaključan prikazati će se ova poruka",
  manual_end: "Kraj upustva",
  work_record_period_closed_and_cannot_be_changed:
    "Ovaj period je zaključan i ne može se mijenjati",
  work_record_ready_to_finalize_and_cannot_be_changed:
    "Ovaj period je poslan na zaključivanje, za uređivanje promjenite status na 'Nije spremno za zaključivanje'",
  do_you_want_to_unlock_work_record_period: "Želite li otključati period?",
  yes: "Da",
  no: "Ne",
  finalizing_period: "Zaključivanje perioda",
  tutorial_work_records_send_to_finalize:
    "Klikom na pošalji na zaključivanje period se privremeno zaključava i šalje na pregled administratoru prije konačnog zaključivanja perioda. Samo periodi poslani na zaključivanje mogu se zaključiti.",
  personal_data: "Osobni podaci",
  download: "Preuzimanje",
  contact_us_for_deleting_user_data: "Kontaktirajte nas za brisanje računa.",
  personal_data_download_text:
    "Vaš korisnički račun sadrži osobne podatke koje ste nam dali na korištenje. Na ovoj stranici možete preuzeti ili obrisati te podatke.",
  personal_data_delete_text:
    "Brisanjem ovih podataka bespovratno se briše i vaš korisnički račun. Ako se odlučite na ovu akciju vaš račun i podatke više nije moguće vratiti.",
  login_again_with_new_user_details:
    "Prijavite se sa novim korisničkim podacima",
  profile: "Profil",
  username: "Korisničko ime",
  email: "E-mail",
  save_changes: "Spremi promjene",
  you: "Vi",
  total: "Ukupno",
  client: "Klijent",
  name: "Naziv",
  not_ready_to_finalize: "Nije spremno za zaključivanje",
  send_to_finalize: "Pošalji na zaključivanje",
  login_or_using_app_in_period:
    "Prva prijava ili ulazak u aplikaciju u periodu",
  send_again: "Pošalji ponovno",
  delete_report: "Obriši izvješće",
  are_you_sure_you_want_to_delete_report:
    "Jeste li sigurni da želite obrisati izvješće i sve stavke izvješća?",
  report_details: "Detalji izvješća",
  active_users: "Aktivnih korisnika",
  is_sent: "Poslano",
  last_month: "Prošli mjesec",
  next_month: "Sljedeći mjesec",
  packets: "Paketi",
  actions: "Akcije",
  editing_settings: "Uređivanje postavki",
  companiesLowerCase: "poduzeća",
  application_packets: "Aplikacijski paketi",
  adding_packet: "Dodavanje paketa",
  sql_form: "SQL forma",
  sql_response: "SQL odgovor",
  fix_and_run_query: "Ispravite i pokrenite upit",
  start_query: "Pokrenite upit",
  add: "Dodaj",
  add_packet: "Dodaj paket",
  company_does_not_have_any_packets:
    "Poduzeće nema aktivnih aplikacijskih paketa",
  without_company: "Bez poduzeća",
  without_user: "Bez korisnika",
  mimic: "Oponašaj",
  editing_user: "Uređivanje korisnika",
  this_user_can_administer_everything:
    "Ovaj korisnik može administrirati svim našim korisnicima",
  firstname: "Ime",
  lastname: "Prezime",
  user_roles: "Uloge korisnika",
  pick: "Odaberite",
  for_pantheon_settings_pick_company:
    "Za prikaz Pantheon postavki odaberite poduzeće",
  pantheon_user: "Pantheon korisnik",
  pick_a_user: "Odaberite korisnika",
  document_types: "Vrste dokumenta",
  default_document_type_is_required: "Zadana vrsta dokumenta je obavezna",
  default_document_type: "Zadana vrsta dokumenta",
  take_from_user: "Preuzmi od korisnika",
  CanChooseDocumentType: "Odabir vrste dokumenta",
  MakePDFOnFinalizingOrder: "Izradi PDF iz narudžbe",
  WarnIfOrderItemQuantityMoreThanAvailable:
    "Upozori ako je količina stavke veća od dostupne",
  PrintOnFinalizingOrder: "Napravi ispis iz narudžbe",
  ShowOnlyAvailableItemsInStockItemsView:
    "U pregledu skladišta prikaži samo dostupne artikle",
  StockInitiallyShowAllAvailableOnStock:
    "Inicijalno prikaži sve artikle na skladištu u pregledu skladišta",
  InitiallyShowAllAvailableOnStock:
    "Inicijalno prikaži sve artikle na skladištu u pretraživanju",
  SquareTilesForArticlePicker: "Pločice kod odabira artikla",
  RestrictSearchToSmallerSet: "Ograniči pretragu na 10 artikala",
  UseCachingForArticleSearch: "Koristi predmemoriju",
  UseCachingForCustomerSearch: "Koristi predmemoriju",
  RepeatLastArticleSearch: "Ponovi prethodno pretraživanje artikala",
  DetailedItemViewInDocument: "Detaljni prikaz kod liste dodanih artikala",
  UseCachingForWorkOrders: "Koristi predmemoriju",
  CacheDuration: "Trajanje (minute)",
  BluetoothPrintCopiesNumber: "Broj kopija kod ispisa",
  UseDarkTheme: "Koristi tamnu temu",
  OrderShouldMakeAReservation: "Izradi rezervaciju na skladištu iz narudžbe",
  CanEditOrderItemPrice: "Promjena cijene",
  DisalowOrderItemQuantityMoreThanAvailable:
    "Količina stavke nesmije biti veća od dostupne",
  UseSerialForItems: "Koristi serijski broj za stavke",
  CanDeleteOrderItems: "Može brisati stavke narudžbe",
  CanDeleteMoveItems: "Može brisati stavke otpremnice",
  warehouse: "Skladište",
  article_search: "Pretraživanje artikala",
  customer_search: "Pretraživanje primatelja",
  viewing_selected_articles: "Prikaz odabranih artikala",
  work_orders: "Radni nalozi",
  cache: "Predmemorija",
  print: "Ispis",
  rest: "Ostalo",
  internal: "Interno",
  documents: "Dokumenti",
  confirm_download: "Potvrdi preuzimanje",
  onix_phone_settings: "Onix Phone postavke",
  last_reported_version: "Verzija na klijentu",
  ares_version_source_cached: "Spremljena vrijednost",
  ares_version_source_unavailable: "Provjera nije dostupna",
  ares_update_queued: "Ažuriranje aresa je pokrenuto u pozadini.",
  ares_update_queued_all_databases:
    "Ažuriranje aresa je pokrenuto u pozadini za ovu i povezane baze.",
  ares_update_in_progress: "Ažuriranje aresa je u tijeku.",
  ares_update_in_progress_all_databases:
    "Ažuriranje aresa je u tijeku na ovoj i povezanim bazama.",
  ares_update_finished: "Ažuriranje aresa je završeno.",
  ares_update_finished_all_databases:
    "Ažuriranje aresa je završeno na ovoj i povezanim bazama.",
  ares_update_failed: "Ažuriranje aresa je završilo s greškom.",
  ares_update_failed_all_databases:
    "Ažuriranje aresa je završilo s greškom na ovoj ili povezanim bazama.",
  ares_update_state_queued: "Čeka",
  ares_update_state_running: "U tijeku",
  ares_update_state_finished: "Gotovo",
  ares_update_state_failed: "Greška",
  last_token_refresh: "Obnova",
  last_login: "Zadnje korištenje / prijava",
  onix_phone_details: "Onix Phone detalji",
  none: "Nema",
  pantheon_not_connected_cannot_change:
    "Pantheon nije povezan, uređivanje nije moguće",
  pantheon_successfully_connected: "Pantheon uspješno povezan",
  adding_user: "Dodavanje korisnika",
  loading: "Učitavanje",
  password: "Lozinka",
  add_a_user: "Dodaj korisnika",
  company_not_selected: "Nije odabrano poduzeće",
  onix_phone: "Onix Phone",
  version: "Verzija",
  platform: "Platforma",
  active: "Aktivan",
  new_user: "Novi korisnik",
  change_user: "Izmijeni korisnika",
  user_search: "Pretraživanje korisnika",
  show_deactivated: "Prikaži dekativirane",
  loading_initial_user_settings: "Inicijalno učitavanje korisničkih postavki",
  you_have_no_applications: "Nemate pristup aplikacijama",
  "The Email field is required.": "Polje E-mail je obavezno.",
  "The Email field is not a valid e-mail address.":
    "Polje mora biti ispravna E-mail adresa.",
  "The Title field is required.": "Polje Naslov je obavezno.",
  "The Message field is required.": "Polje Poruka je obavezno.",
  username_or_email: "Korisničko ime ili e-mail",
  login: "Prijava",
  key: "Ključ",
  value: "Vrijednost",
  mimicking_user: "Oponašanje korisnika",
  mimicking_in_progress: "Oponašanje korisnika u tijeku",
  page_not_found: "Stranica nije pronađena",
  link: "Link",
  is_written_wrong_or_does_not_exist_anymore:
    "je krivo napisan ili više nije dostupan",
  back: "Povratak",
  back_to_dashboard: "Nazad na početnu",
  not_possible_to_delete_cost_type:
    "Nije moguće obrisati vrstu troška '{0}', postoje evidencije rada koje ju koriste. Ovu vrstu troška možete deaktivirati kako se ne bi koristila u buduće.",
  company_settings: "Postavke poduzeća",
  cost_types: "Vrste troška",
  you_have_no_cost_types: "Nemate povezane vrste zarade",
  add_cost_type: "Dodaj vrstu troška",
  editing_cost_type: "Uređivanje vrste troška",
  adding_cost_type: "Dodavanje nove vrste troška",
  code: "Šifra",
  active_cost_types_tooltip:
    "Aktivne vrste troška mogu se koristiti kod dodavanja evidencije rada",
  data_sync: "Sinkronizacija podataka",
  sync_in_progress: "Sinkronizacija u tijeku...",
  last_check: "Zadnja provjera",
  last_sync: "Zadnja sinkronizacija",
  start_sync: "Pokreni sinkronizaciju",
  user_not_active: "Korisnik nije aktivan",
  save_password: "Spremi lozinku",
  administrator: "Administrator",
  name_and_surname: "Ime i prezime",
  company_users: "Korisnici poduzeća",
  current_password: "Trenutna lozinka",
  new_password: "Nova lozinka",
  repeat_password: "Ponovite novu lozinku",
  change_password: "Ažuriraj lozinku",
  password_changed_successfully: "Uspješno ste promijenili lozinku.",
  total_hours: "Ukupan broj sati",
  change_worker_cost_type_or_period:
    "Pokušajte promjeniti radnika, vrstu troška ili period",
  date: "Datum",
  time: "Vrijeme",
  description: "Opis",
  no_user: "Bez korisnika",
  from: "Od",
  to: "Do",
  all_dropdown: " - Svi - ",
  month_picker: "Odabir mjeseca",
  reset_to_default: "Vrati na zadano",
  by_cost_bearer: "Po nositelju",
  by_cost_type: "Po vrsti troška",
  by_worker: "Po radniku",
  worker: "Radnik",
  close: "Zatvori",
  all_workers: "Svih radnika",
  rest_of_workers: "Preostalih radnika",
  only_picked_workers: "Samo odabranih radnika",
  for_this_period_data_exists_in_pantheon:
    "Za ovaj period već postoje podaci u Pantheonu. Moguće je prenijeti samo podatke preostalih radnika.",
  start_data_upload: "Pokreni prijenos podataka",
  period: "Period",
  period_is_locked: "Period je zaključan",
  unlock_all: "Otključaj sve",
  lock_all: "Zaključi sve",
  no_items_for_selected_period: "Nema stavaka za odabrani period",
  save_note: "Spremi napomenu",
  year: "Godina",
  month: "Mjesec",
  on_date: "Na datum",
  "User not ready":
    "Ovaj korisnik nije postavljen, kontaktirajte nas za pomoć.",
  "User not found": "Korisnik nije pronađen.",
  "The UserNameOrEmail field is required.":
    "Polje 'Korisničko ime ili e-mail' obavezno je ispuniti.",
  "Invalid password": "Upisali ste neispravnu lozinku.",
  no_results: "Nema rezultata",
  pick_month: "Odaberite mjesec",
  no_items: "Nema stavaka",
  or: "Ili",
  never: "Nikad",
  pick_date: "Odaberite datum",
  calendar: "Kalendar",
  no_workers_for_selected_period: "Nema radnika sa podacima za odabrani period",
  not_sent_to_finalize: "Nije poslano na zaključivanje",
  "Polje trenutna lozinka je obavezno.": "Polje trenutna lozinka je obavezno.",
  "Polje nova lozinka je obavezno.": "Polje nova lozinka je obavezno.",
  "Nova lozinka i ponovljena lozinka se ne podudaraju.":
    "Nova lozinka i ponovljena lozinka se ne podudaraju.",
  "Nova lozinka mora imati barem 6 i najviše 100 znakova.":
    "Nova lozinka mora imati barem 6 i najviše 100 znakova.",
  "Trenutna lozinka neispravna.": "Trenutna lozinka neispravna.",
  work_records_transfer_successful: "Prijenos podataka uspješno izvršen",
  there_was_an_error: "Došlo je do greške",
  add_multiple_work_hours: "Dodaj odabrane radne sate",
  are_you_sure_you_want_to_delete_work_record:
    "Jeste li sigurni da želite obrisati cijeli redak uključujući i njegove radne sate?",
  details: "Detalji",
  untoggle_multiple_work_hours: "Odznači radne sate",
  selected_days_for_work_hours: "Odabrani dani",
  adding_multiple_work_hours: "Dodavanje više radnih sati",
  number_of_multiple_work_hours: "Broj odabranih sati",
  exceeding_work_hours_for: "Dani za koje bi broj radnih sati prelazio 24 sata",
  support: "Podrška",
  "onix-clr-installations": "Onix CLR instalacije",
  "add-onix-clr-installation": "Dodaj Onix CLR instalaciju",
  "edit-onix-clr-installation": "Uredi Onix CLR instalaciju",
  "last-reported-on": "Zadnje javljeno",
  "add-company-machine-uid": "Dodaj Company Machine UID",
  "edit-company-machine-uid": "Uredi Company Machine UID",
  "link-by-database-and-machine": "Poveži po bazi i računalu",
  "link-by-machine": "Poveži samo po računalu",
  "link-onix-clr-installations": "Poveži Onix CLR instalacije",
  "selected-onix-clr-installations-count": "Odabrano: {{count}}",
  "select-onix-clr-installations": "Prvo odaberite Onix CLR instalacije.",
  "select-company-for-onix-clr-linking": "Prvo odaberite poduzeće.",
  "onix-clr-link-missing-machine-uid":
    "Odabrani redovi nemaju UID računala: {{machineUids}}",
  "onix-clr-link-missing-database":
    "Ovi UID-evi računala trebaju bazu za povezivanje po bazi i računalu: {{machineUids}}",
  "onix-clr-link-different-company-blocked":
    "Ovi UID-evi računala već imaju isto mapiranje na drugo poduzeće. Prvo uredite ta mapiranja: {{machineUids}}",
  "onix-clr-link-already-exists": "Sve odabrane instalacije su već povezane.",
  "onix-clr-installations-pivot-installations": "Instalacije",
  "onix-clr-installations-pivot-mappings": "Mapiranje poduzeća",
  "onix-clr-installations-pivot-unmapped": "Nemapirani strojevi",
  "onix-clr-installations-pivot-audit": "Kontrola korištenja",
  "show-only-unmapped-installations": "Prikaži samo nemapirane strojeve (s preporukom)",
  "onix-clr-unmapped-machines-description":
    "Strojevi koji još nemaju mapiranje na poduzeće, s preporukom poduzeća prema nazivu baze.",
  "onix-clr-recommended-company": "Preporučeno poduzeće",
  "onix-clr-recommendation-score": "Ocjena",
  "onix-clr-recommendation-reason": "Razlog preporuke",
  "onix-clr-recommendation-exact-match": "Točno podudaranje baze i poduzeća",
  "onix-clr-recommendation-database-contains-company":
    "Naziv baze sadrži naziv poduzeća",
  "onix-clr-recommendation-company-contains-database":
    "Naziv poduzeća sadrži naziv baze",
  "onix-clr-recommendation-shared-tokens": "Zajednički tokeni naziva",
  "onix-clr-audit-non-public-not-allowed":
    "Korištenje ne-javnih Ares grupa koje nije dozvoljeno",
  "onix-clr-audit-company-not-allowed":
    "Baze poduzeća koje još nisu dozvoljene za CLR",
  "onix-clr-audit-usage-without-mapping":
    "Baze koje šalju CLR izvještaj bez DMS mapiranja",
  "onix-clr-audit-issue": "Problem",
  "onix-clr-not-allowed": "Nije dozvoljeno",
  "onix-clr-issue-installation-not-allowed": "Instalacija nije dozvoljena",
  "onix-clr-issue-company-not-mapped-to-group":
    "Poduzeće nije mapirano na ovu ne-javnu Ares grupu",
  "onix-clr-issue-installation-and-company-not-mapped":
    "Instalacija nije dozvoljena i poduzeće nije mapirano na ovu ne-javnu Ares grupu",
  generated: "Generirano",
  connect: "Poveži",
  instance: "Instanca",
  edition: "Izdanje",
  machineUID: "UID računala",
  allowed: "Dozvoljeno",
  "data-already-uploaded": "Podaci su već prebačeni",
  "data-not-ready-to-finalize":
    "Podaci nisu označeni kao spremni za zaključivanje",
  "data-not-finalized": "Podaci nisu zaključeni",
  contact: "Kontakt",
  priority: "Prioritet",
  source: "Izvor",
  status: "Status",
  type: "Vrsta",
  agent: "Vlasnik",
  Open: "Otvoreno",
  Closed: "Zatvoreno",
  Pending: "Na čekanju",
  Resolved: "Riješeno",
  WaitingOnCustomer: "Čeka se korisnik",
  WaitingOnThirdParty: "Čeka se treća strana",
  Low: "Nisko",
  Medium: "Srednje",
  High: "Visoko",
  Urgent: "Hitno",
  Phone: "Telefon",
  due_date: "Datum kraja",
  "add-ticket": "Dodaj tiket",
  "ticket-is-due": "Datum kraja tiketa je prošao",
  "new-ticket": "Novi tiket",
  "ticket-details": "Detalji tiketa",
  "assigned-to": "Dodijeljeno",
  "reported-by": "Prijavio",
  title: "Naslov",
  unresolved: "Neriješeno",
  overdue: "Kasni",
  dueToday: "Danas završava",
  open: "Otvoreno",
  onHold: "Na čekanju",
  mine: "Moji",
  reply: "Odgovori",
  "add-note": "Dodaj napomenu",
  forward: "Proslijedi",
  "save-filter": "Spremi filter",
  filter: "Filter",
  "no-saved-user-filters": "Nemate spremljenih filtera",
  "saving-user-filter": "Dodavanje filtera",
  "editing-user-filter": "Uređivanje filtera",
  "writing-response-note": "Dodavanje nove bilješke",
  "writing-response-reply": "Odgovor korisniku",
  "writing-response-forward": "Proslijeđivanje razgovora",
  "writing-response-new": "Novi tiket",
  content: "Sadržaj",
  "time-logs": "Vrijeme rada",
  "no-time-logs": "Nema upisanog vremena rada",
  "add-time-log": "Dodaj vrijeme rada",
  billable: "Naplativo",
  "total-time-tracked": "Ukupno vrijeme rada",
  "ai-8x-recommended": "AI x{{multiplier}} preporuka za račun: {{value}}",
  "ai-8x-recommended-total": "AI x{{multiplier}} preporučeno ukupno",
  "ai-8x-recommended-short": "AI x{{multiplier}}",
  "ai-type": "AI / Codex",
  edit: "Uredi",
  travel_warrants: "Putni nalozi",
  travel_warrants_settings: "Postavke putnih naloga",
  work_records_settings: "Postavke evidencije rada",
  general_tenant_settings: "Opće postavke",
  "document-id": "Ključ dokumenta",
  "start-date": "Datum početka",
  "end-date": "Kraj",
  "expense-bearer": "Nositelj troška",
  "new-travel-warrant": "Novi putni nalog",
  "no-travel-warrants-for-filter": "Nema putnih naloga za odabrani filter",
  CLOSED: "Zatvoren",
  OPEN: "Otvoren",
  SENT_TO_PANTHEON: "Poslan u pantheon",
  "show-travel-warrant-items": "Prikaži stavke",
  "no-travel-warrant-items-for-travel-warrant": "Ovaj putni nalog nema stavaka",
  "cost-type": "Vrsta troška",
  currency: "Valuta",
  "new-travel-warrant-item": "Nova stavka putnog naloga",
  "The ExpenseBearerId field is required.": "Odaberite nositelja troška",
  "The CostTypeId field is required.": "Odaberite vrstu troška",
  "The Currency field is required.": "Odaberite valutu",
  "travel-warrant-items": "Troškovi",
  "The Value field is required.": "Unesite vrijednost",
  this_user_is_deactivated: "Ovaj korisnik nije aktivan",
  "no-items-for-search": "Nema stavki za odabrani filter",
  contacts: "Kontakti",
  codebooks: "Šifranti",
  fullname: "Ime i prezime",
  address: "Adresa",
  isPrimary: "Primarno",
  notes: "Bilješke",
  "close-travel-warrant": "Zatvori putni nalog",
  "open-travel-warrant": "Otvori putni nalog",
  "edit-travel-warrant-item": "Uređivanje troška",
  "Travel warrant is closed": "Putni nalog je zatvoren",
  "contact-companies": "Poduzeća kontakta",
  "no-items": "Nema stavaka",
  search: "Pretraživanje",
  emails: "E-Mail adrese",
  "contact-emails": "E-mail adrese",
  "support-settings": "Postavke podrške",
  "ticket-signature": "Potpis",
  "support-tenant-settings": "Postavke podrške",
  "support-email": "Email za podršku",
  "support-auto-reply-on-new-ticket":
    "Pošalji automatsku potvrdu odmah nakon otvaranja novog ticketa",
  "support-auto-reply-on-new-ticket-subject":
    "Predmet automatske potvrde za novi ticket",
  "support-auto-reply-on-new-ticket-body":
    "Poruka automatske potvrde za novi ticket",
  "support-auto-reply-placeholders":
    "Možete koristiti rich text formatiranje. Dostupni placeholderi: {{ticketNumber}}, {{ticketTitle}}, {{contactName}}, {{supportEmail}}, {{companyName}}",
  "ai-support-settings-tab": "AI podrška",
  "ai-support-settings-description":
    "Podesite API ključ, modele i ograničenja AI istražitelja po poduzeću.",
  "ai-support-api-key": "API ključ",
  "ai-support-api-key-placeholder": "Opcionalni ključ za ovo poduzeće",
  "ai-support-api-key-description":
    "Ostavite prazno ako za ovo poduzeće želite i dalje koristiti serverski fallback ključ.",
  "ai-support-api-key-fallback-note":
    "Ovdje možete spremiti API ključ za ovo poduzeće. Ako ga ostavite praznim, koristit će se serverski fallback ključ.",
  "ai-support-settings-starting-point":
    "Dobra početna postavka: manji/jeftiniji model za triage, jači model za investigation, reasoning effort Medium, verbosity Concise, {{maxToolRounds}} tool rundi, {{maxInputTokensPerTurn}} maksimalnih ulaznih tokena, {{maxOutputTokensPerTurn}} maksimalnih izlaznih tokena i {{defaultTimeoutMinutes}} minute timeouta.",
  "ai-support-models-loading":
    "Učitavam dostupne modele za ovaj API ključ...",
  "ai-support-models-loaded":
    "Učitano je {{count}} dostupnih modela. Možete odabrati iz padajućeg izbornika ili ručno upisati ID modela.",
  "ai-support-models-load-failed":
    "Nije moguće dohvatiti modele za ovaj API ključ: {{error}}",
  "ai-support-models-load-failed-generic":
    "Nije moguće dohvatiti modele za ovaj API ključ.",
  "ai-support-models-empty":
    "Za ovaj API ključ nije vraćen nijedan model. I dalje možete ručno upisati ID modela.",
  "ai-support-triage-model": "Triage model",
  "ai-support-triage-model-placeholder": "Unesite ID triage modela",
  "ai-support-triage-model-description":
    "Ovdje koristite manji i jeftiniji model jer triage ne radi cijelu investigation petlju.",
  "ai-support-investigation-model": "Investigation model",
  "ai-support-investigation-model-placeholder":
    "Unesite ID investigation modela",
  "ai-support-investigation-model-description":
    "Ovdje koristite jači model jer on vodi tool pozive i završni zaključak.",
  "ai-support-reasoning-effort": "Reasoning effort",
  "ai-support-verbosity": "Sažetost prikaza razmišljanja",
  "ai-support-run-budget-mode": "Način budžeta izvođenja",
  "ai-support-run-budget-mode-bounded": "Ograničeno",
  "ai-support-run-budget-mode-run-until-terminal": "Radi do završnog ishoda",
  "ai-support-run-budget-mode-bounded-note":
    "AI runovi su uvijek ograničeni. AI dobiva uputu da završi u što manje runova, a automatski nastavci se i dalje zaustavljaju na thread-level limitima.",
  "ai-support-run-budget-mode-run-until-terminal-note":
    "Način 'radi do završnog ishoda' ignorira timeout i limit koraka po runu. AI nastavlja dok ne odgovori, ne zaključi, ne postavi follow-up pitanje, ne zatraži pristup ili stvarno ne padne.",
  "ai-support-bounded-only-setting-note":
    "Ova postavka vrijedi samo u ograničenom načinu rada.",
  "ai-support-max-tool-rounds": "Maksimalan broj tool rundi",
  "ai-support-max-input-tokens": "Maksimalan broj ulaznih tokena po koraku",
  "ai-support-max-output-tokens": "Maksimalan broj izlaznih tokena po koraku",
  "ai-support-timeout-minutes": "Timeout (minute)",
  "ai-support-reasoning-effort-minimal": "Minimalan",
  "ai-support-reasoning-effort-low": "Nizak",
  "ai-support-reasoning-effort-medium": "Srednji",
  "ai-support-reasoning-effort-high": "Visok",
  "ai-support-reasoning-effort-none": "Bez reasoninga",
  "ai-support-verbosity-description": "Utječe na sažetak razmišljanja, a ne na duljinu konačnog odgovora.",
  "ai-support-input-budget-description": "Približan budžet početnog konteksta. Ne ograničava cijelu povijest razgovora.",
  "ai-support-output-budget-description": "Uključuje razmišljanje i vidljiv odgovor. Postavke se zamrzavaju pri pokretanju razgovora.",
  "ai-support-output-budget-warning": "Izlazni budžet ispod 8000 tokena može prekinuti razmišljanje ili odgovor. Za početak koristite 16000 tokena.",
  "ai-support-verbosity-auto": "Auto",
  "ai-support-verbosity-concise": "Sažeto",
  "ai-support-verbosity-detailed": "Detaljno",
  "ai-support-settings-warning-over-default":
    "{{field}} je iznad preporučene vrijednosti (preporuka: {{recommended}}, trenutno: {{current}}).",
  "ai-support-triage-model-required": "Unesite triage model.",
  "ai-support-investigation-model-required":
    "Unesite investigation model.",
  "ai-support-reasoning-effort-required": "Odaberite reasoning effort.",
  "ai-support-verbosity-required": "Odaberite verbosity.",
  "ai-support-max-tool-rounds-required":
    "Maksimalan broj tool rundi mora biti veći od nule.",
  "ai-support-max-input-tokens-required":
    "Maksimalan broj ulaznih tokena mora biti veći od nule.",
  "ai-support-max-output-tokens-required":
    "Maksimalan broj izlaznih tokena mora biti veći od nule.",
  "ai-support-timeout-minutes-required":
    "Timeout mora biti veći od nule.",
  "received-from-contact": "Od korisnika",
  "sent-to-contact": "Poslano korisniku",
  "added-note": "napomena od",
  by: "od",
  cost_group_options: "Grupa troška",
  "The PantheonCostGroup field is required.": "Odaberite grupu troška",
  "The CostType field is required.": "Unesite naziv vrste troška",
  "The PantheonCostType field is required.": "Odaberite vrstu zarade",
  "travel-warrants-overview": "Pregled putnih naloga",
  "personal-vehicles": "Osobna vozila",
  "editing-new-personal-vehicle": "Uređivanje osobnog vozila",
  "adding-new-personal-vehicle": "Dodavanje osobnog vozila",
  makeAndModel: "Model i marka",
  registration: "Registracija",
  header: "Zaglavlje",
  "personal-vehicle": "Osobno vozilo",
  "official-vehicle": "Službeno vozilo",
  personal: "Osobno",
  official: "Službeno",
  "travel-type": "Prijevozno sredstvo",
  country: "Država",
  place: "Mjesto",
  "edit-other-personal-vehicles": "Uređivanje ostalih osobnih vozila",
  driver: "Vozač",
  codriver: "Suvozač",
  "save-header-changes": "Spremi promijene",
  "travel-start-date-time": "Početak puta",
  basic: "Osnovno",
  transport: "Prijevoz",
  "travel-details": "Detalji puta",
  "adding-travel-warrant-item": "Dodavanje troška",
  "editing-travel-warrant-item": "Uređivanje troška",
  "Travel start date time must be before travel end time":
    "Mora biti prije povratka",
  "Travel start meter must be less than travel end meter":
    "Mora biti manje od povratka",
  costTypeId: "Vrsta troška",
  "meter-state": "Stanje brojila",
  "date-of-departure": "Datum polaska",
  "date-of-return": "Datum povratka",
  report: "Izvješće",
  currencyId: "Valuta",
  "The CurrencyId field is required.": "Odaberite valutu",
  "travel-warrant": "Putni nalog",
  "The Date field is required.": "Odaberite datum",
  "image-picking": "Odabir slike",
  "time-of-departure": "Vrijeme polaska",
  "time-of-return": "Vrijeme povratka",
  "enter-a-valid-time": "Unesite ispravno vrijeme",
  allowance: "Džeparac",
  "total-per-diems": "Broj dnevnica",
  "has-backing-invoice": "R1 račun",
  hasBackingInvoice: "R1 račun",
  "send-to-pantheon": "Pošalji u Pantheon",
  "travel-warrant-closed": "Putni nalog je zatvoren",
  "travel-warrant-sent-to-pantheon": "Putni nalog je poslan u Pantheon",
  travels: "Putovanje",
  "travel-type-short": "Prijevoz",
  meter: "Brojilo",
  departure: "Polazak",
  return: "Povratak",
  expenses: "Troškovi",
  notForPayment: "Ne isplaćuje se",
  "total-km": "Ukupno KM",
  "adding-new-contact": "Dodavanje kontakta",
  "editing-contact": "Uređivanje kontakta",
  "paging-showing": "Prikazano je",
  "paging-of": "od",
  "paging-on-page": "na stranici",
  page: "Stranica",
  fullName: "Ime i prezime",
  webshop: "Web trgovina",
  "webshop-items": "Web trgovina - artikli",
  "adding-web-shop-item": "Dodavanje artikla",
  "editing-web-shop-item": "Uređivanje artikla",
  featured: "Istaknuto",
  discounted: "Prikaži sniženu cijenu",
  "featured-categories": "Istaknuto",
  "adding-featured-category": "Dodavanje istaknute kategorije",
  "editing-featured-category": "Uređivanje istaknute kategorije",
  "To Pantheon": "U Pantheon",
  "From Pantheon": "Iz Pantheon-a",
  "confirm-changing-travel-warrant-status-to-closed":
    "zatvoriti putni nalog? Ako zatvorite putni nalog više ga nije moguće otvoriti. Zatvoreni putni nalog pokušati će se poslati u Pantheon odmah ili kod sljedeće sinkronizacije podataka. Da li želite nastaviti?",
  "confirm-changing-travel-warrant-status-to-closed_lock":
    "zaključati putni nalog? Ako zaključite putni nalog više ga nije moguće otvoriti. Zaključeni putni nalog pokušati će se poslati u Pantheon odmah ili kod sljedeće sinkronizacije podataka. Da li želite nastaviti?",
  "there-was-an-error-while-syncing": "Došlo je do greške kod sinkronizacije",
  travel_warrants_from_dashboard:
    "Klikom na 'Putni nalozi' možete početi unositi putne naloge.",
  travel_warrants_status_dropdown:
    "Klikom na padajući izbornik 'Status' možete odabrati filter po statusu putnog naloga. Putne naloge sa statusom 'Otvoren' moguće je uređivati, oni sa statusom 'Zatvoren' u pripremi su za slanje na vaš Pantheon, sa statusom 'Poslano u Pantheon' već su spremljeni u vašem Pantheon sustavu.",
  tutorial_travel_warrant_worker:
    "Kao administrator možete pregledavati putne naloge svih radnika vašeg poduzeća",
  travel_warrants_search_component:
    "Ovdje možete upisati pojam za pretraživanje putnih naloga",
  travel_warrants_table_status_explanation:
    "Ako je status 'Zatvoren', a nije crvene boje, putni nalog je još u pripremi za slanje. Ako je status 'Zatvoren' i crvene je boje, došlo je do greške kod sinkronizacije. Klikom na taj putni nalog možete vidjeti više detalja.",
  travel_warrants_add_travel_warrant:
    "Klikom na 'Dodaj' otvara se forma za dodavanje novog putnog naloga",
  new_travel_warrant_tab:
    "Sadržaj kartice 'Putovanje' prikazuje zaglavlje putnog naloga.",
  tutorial_travel_warrant_pick_worker:
    "Kao administrator možete odabrati radnika za kojeg radite putni nalog.",
  new_travel_warrant_pick_project:
    "Ovdje možete odabrati projekt. Ako subjekt projekta ima povezano mjesto i državu, ispuniti će se i polja mjesto i država.",
  "new-travel-warrant-general-transport":
    "Ovdje možete upisati način prijevoza ako ne koristite službeno ili osobno vozilo",
  "new-travel-warrant-official-vehicle":
    "Ovdje možete odabrati službena vozila preuzeta iz vašeg Pantheon sustava",
  "new-travel-warrant-personal-vehicle":
    "Ako koristite osobno vozilo ovdje možete odabrati osobna vozila povezana sa vašim korisnikom",
  "new-travel-warrant-arrival-date":
    "Postavite datum i vrijeme polaska i povratka kako bi mogli izračunati broj dnevnica",
  "new-travel-warrant-personal-vehicle-callout":
    "Za dodavanje novog osobnog vozila kliknite ovdje, u formi koja se otvara možete kliknuti na link 'Uređivanje ostalih osobnih vozila' koji vas vodi na stranicu za pregled i uređivanje vaših postojećih osobnih vozila",
  "new-travel-warrant-items-tab":
    "Jednom kada spremite zaglavlje prikazati će vam se i kartica 'Troškovi' gdje možete dodavati troškove puta",
  "new-travel-warrant-items-table":
    "Ovdje možete vidjeti troškove koje ste dodali na putni nalog i zbrojene troškove ako ulaze u sumu. Ako trošak ima oznaku 'Ne isplaćuje se' ne uključuje se u ukupan trošak.",
  "manual-is-active":
    "Upustva su aktivna, ako je došlo do problema sa uputstvima kliknite ovdje za deaktivaciju upustva.",
  "travel-warrant-header-has-unsaved-changes":
    "Zaglavlje ovog putnog naloga ima nespremljene promijene, jeste li sigurni da želite otići sa ove stranice?",
  "Personal vehicle does not belong to this user":
    "Vozilo ne pripada korisniku",
  "Travel warrant country not set": "Odaberite državu",
  "adding-new-company": "Dodavanje novog poduzeća",
  "editing-company": "Uređivanje poduzeća",
  companyId: "Poduzeće",
  contactId: "Kontakt",
  "adding-new-email": "Dodavanje email-a",
  "editing-email": "Uređivanje email-a",
  "The ContactCompanyId field is required.": "Poduzeće kontakta je obavezno",
  "no-tickets": "Nema tiketa za trenutni filter",
  "is-primary": "Primarni",
  "The ContactEmailId field is required.": "Odaberite Email",
  "The ContactId field is required.": "Odaberite kontakt",
  "unread-messages": "Nepročitanih poruka",
  testing: "Testiranje",
  BluetoothPrinterCharacterWidth: "Širina papira",
  travelEndDateTime: "Kraj puta",
  "travel-end-date-time": "Kraj puta",
  conversion: "Tečaj",
  "The Conversion field is required.": "Unesite tečaj",
  "delete-travel-warrant": "obrisati putni nalog?",
  "expenses-total": "Troškovi ukupno",
  "down-payment": "Predujam",
  "daily-allowance": "Dnevnica",
  quantity: "Količina",
  "travel-warrant-is-sent-to-finalize":
    "Ovaj putni nalog je poslan na zaključivanje, za uređivanje promjenite status na 'Nije spremno za zaključivanje'",
  "Travel warrant is sent to finalize":
    "Ovaj putni nalog je poslan na zaključivanje",
  SENT_TO_FINALIZE: "Poslan na zaključivanje",
  "travel-warrant-is-closed": "Ovaj putni nalog je zatvoren",
  "travel-warrant-is-closed_lock": "Ovaj putni nalog je zaključen",
  amount: "Iznos",
  "cost-description": "Opis troška",
  attachment: "Prilog",
  "picking-attachment": "Odabir priloga",
  "departure-place": "Mjesto polaska",
  "enter-valid-date-range": "Unesite ispravan raspon datuma",
  send: "Pošalji",
  "add-attachment": "Dodaj privitak",
  "Pick a currency": "Odaberite valutu",
  "Enter a conversion rate": "Unesite tečaj",
  "notify-email-or-agent": "Obavijesti agenta",
  "save-as-new-filter":
    "Spremi trenutno aktivne postavke filtera kao novi filter",
  modifiedOn: "Promjena",
  createdOn: "Izrada",
  "no-title": " - Bez naslova - ",
  "connect-to-contact": "Prebaci E-mail adrese",
  "support-email-password": "Lozinka E-mail podrške",
  "sql-error-547": "Postoje povezani podaci koji koriste ovaj redak",
  "unknown-sql-error": "Nepoznata greška na SQL poslužitelju",
  "contact-and-company": "Kontakt i poduzeće",
  "status-and-agent": "Status i agent",
  Today: "Danas",
  Yesterday: "Jučer",
  ThisWeek: "Ovaj tjedan",
  ThisMonth: "Ovaj mjesec",
  LastMonth: "Prošli mjesec",
  CustomRange: "Raspon datuma",
  "support-redirect-all-to-sender":
    "Preusmjeri sve odlazne mailove pošiljatelju",
  import: "Uvoz",
  "saved-files-settings": "Postavke spremanja datoteka",
  id: "Id",
  "temporary-agent": "Agent",
  support_dashboard: "Pregled",
  "status-and-priority": "Status i prioritet",
  "notify-of-unread-messages": "Pošalji E-mail za svaku novu poruku",
  "do-you-want-to-delete": "Jeste li sigurni da želite obrisati {subject}?",
  "genitiv-message": "poruku",
  "writing-response-edit-note": "Uređivanje napomene",
  "save-note": "Spremi promjene",
  "other-settings": "Ostalo",
  croatian: "Hrvatski",
  english: "Engleski",
  dashboard: "Početna",
  "codebooks-companies": "Poduzeća",
  "codebooks-contacts": "Kontakti",
  "support-dashboard": "Pregled podrške",
  "edit-ticket": "Pregled",
  "activity-reports": "Izvješća aktivnosti",
  "activity-records": "Stavke izvješća aktivnosti",
  "work-records-overview": "Pregled evidencije rada",
  "work-records": "Evidencija rada",
  finalize: "Zaključivanje",
  upload: "Prijenos",
  "travel-warrants": "Putni nalozi",
  italian: "Talijanski",
  other: "Ostalo",
  "open-tasks": "Zadaci",
  "remove-ticket": "Obriši tiket",
  "are-you-sure-you-want-to-delete-this-ticket":
    "obrisati ovaj ticket? Obrisati će se svo njegovo vrijeme rada, poruke i spremljene datoteke/slike.",
  "not-assigned-ticket": "Nedodijeljen tiket",
  "your-ticket": "Vaš tiket",
  "ticket-delegated-to-you": "Vi ste agent",
  "ticket-you-delegated": "Delegirano agentu",
  for: "Za",
  "The AgentId field is required.": "Odaberite agenta",
  "Enter a positive timespan": "Unesite vrijeme",
  "no-title-warning": " - Nema naslova - ",
  project: "Projekt",
  "adding-new-project": "Dodavanje projekta",
  "codebooks-projects": "Projekti",
  "editing-project": "Uređivanje projekta",
  "no-projects-found": "Nisu pronađeni projekti, ili nema aktivnih projekata",
  finished: "Završeno",
  "not-finished": "Nije završen",
  "no-agents-found": "Nisu pronađeni agenti",
  "are-you-sure-you-want-to-close-without-billable-time-log":
    "Ovaj tiket nema naplativog vremena rada, jeste li sigurni da želite nastaviti?",
  "merge-ticket": "Poveži tiket",
  "merge-ticket-from": "Preuzmi sve s tiketa",
  "ticket-cannot-merge-into-itself": "Tiket se ne može spojiti sam u sebe",
  "delete-company": "Obriši poduzeće",
  "deleting-company": "Brišem poduzeće...",
  "delete-company-confirmation":
    "Obrisati poduzeće {{name}}? Brisanje neće proći ako postoje povezani zapisi.",
  "merge-company": "Spoji poduzeće",
  "merge-company-description":
    "Premjesti sve podatke iz drugog poduzeća u ovo.",
  "merge-company-search": "Pronađi poduzeće za spajanje",
  "merge-company-suggestions": "Slična poduzeća",
  "merge-company-confirm": "Spoji u ovo poduzeće",
  "merge-company-conflicts-found":
    "Pronađeni su konflikti. Pregledajte svako polje prije završetka spajanja.",
  "merge-company-preview-description":
    "Odaberite kako se svako polje treba razriješiti prije nego što se izvorno poduzeće spoji u ciljno poduzeće.",
  "merge-company-fields": "Polja",
  "merge-company-related-items": "Povezani zapisi",
  "merge-company-source": "Izvor",
  "merge-company-target": "Cilj",
  "merge-company-action": "Akcija",
  "merge-company-conflict": "Konflikt",
  "merge-company-empty-value": "Prazno",
  "merge-company-resolve-and-merge": "Razriješi i spoji",
  "merge-company-action-keep-target": "Zadrži cilj",
  "merge-company-action-take-source": "Uzmi izvor",
  "merge-company-action-merge-both": "Spoji oba",
  "merge-company-outcome-will-move": "Bit će premješteno",
  "merge-company-outcome-merge-existing": "Spojit će se s postojećim zapisima",
  "merge-company-outcome-no-change": "Bez promjene",
  "merge-company-source-count": "Izvor: {{count}}",
  "merge-company-target-count": "Cilj: {{count}}",
  "merge-contact": "Spoji kontakt",
  "merge-contact-description":
    "Premjesti sve podatke iz drugog kontakta u ovaj.",
  "merge-contact-search": "Pronađi kontakt za spajanje",
  "merge-contact-confirm": "Spoji u ovaj kontakt",
  choose: "Odaberi",
  clear: "Odznači",
  program: "Program",
  tickets: "Tiketi",
  "support-woocommerce-settings": "WooCommerce postavke",
  secret: "Tajna",
  location: "Lokacija",
  AGENTS: "AGENTI",
  "ccemail-not-finished-do-you-want-to-continue":
    "Postoji nedovršen CC e-mail, jeste li sigurni da želite nastaviti?",
  "attachment-mentioned-but-does-not-exist":
    "U poruci je spomenut privitak, ali niste ga dodali, jeste li sigurni da želite nastaviti?",
  todo: "Podsjetnik",
  "no-todos": "Nema podsjetnika",
  "add-todo-button": "Dodaj podsjetnik",
  "mention-agents": "agenti",
  culture: "Država",
  timezone: "Vremenska zona",
  "there-are-some-updates-a-refresh-is-required":
    "Softver je nadograđen, za primjenu osvježite stranicu",
  refresh: "Osvježi",
  "time-format": "Format datuma i vremena",
  support_todos: "Podsjetnici",
  "support-todos": "Podsjetnici",
  "adding-support-todo": "Dodavanje podsjetnika",
  "editing-support-todo": "Uređivanje podsjetnika",
  "ticket-title": "Naslov ticketa",
  dateTime: "Datum",
  ticketId: "Tiket",
  synced: "Sinkronizirano",
  "synchronize-timelogs": "Sinkroniziraj vrijeme rada",
  "document-number": "Broj dokumenta",
  "total-costs": "Ukupno troškovi",
  "Travel warrant expense bearer not set": "Postavite nositelja troška",
  "Travel warrant place not set": "Postavite mjesto",
  "Travel warrant start date and time not set":
    "Postavite datum i vrijeme polaska",
  "Travel warrant end date and time not set":
    "Postavite datum i vrijeme povratka",
  "created-time-log-on-date": "Datum rada",
  "time-log-sync": "Sinkronizacija vremena rada",
  "time-log-exported": "Izvezeno",
  "time-log-exported-on": "Izvezeno {{date}}",
  "time-log-not-exported": "Nije izvezeno",
  "last-month": "Prošli mjesec",
  "current-month": "Ovaj mjesec",
  nextWeek: "Sljedeći tjedan",
  lastWeek: "Prošli tjedan",
  lastDay: "Jučer",
  nextDay: "Sutra",
  last: "Zadnji",
  "responsible-agent": "Odgovorni agent",
  "reset-all": "Obriši sve",
  "are-you-sure": "Jeste li sigurni?",
  "reset-ticket-data": "obrisati sve podatke?",
  "want-to-delete-message": "obrisati poruku?",
  "want-to-regenerate-message": "regenerirati poruku sa novim potpisom?",
  "want-to-close-without-billable-time-log":
    "zatvoriti tiket bez naplativog vremena rada?",
  "want-to-continue-without-attachment": "nastaviti bez privitka?",
  "send-later": "Kasnije",
  "send-later-title": "Izvan radnog vremena: pošalji na početku sljedećeg radnog vremena ({{time}})",
  "scheduled-send": "zakazano slanje: {{time}} (kupac još ne vidi poruku)",
  "send-now": "Pošalji sada",
  "send-scheduled-now-confirm": "poslati poruku odmah?",
  "want-to-merge-contact-with-contact":
    "dodijeliti: {emails} kontaktu {contact}. Svi tiketi i poduzeća prebaciti će se na ovaj kontakt, a kontakt s kojeg se podaci prebacuju biti će obrisan.",
  "want-to-continue-to-delete-without-where-query":
    "nastaviti sa DELETE naredbom iako niste naveli WHERE ograničenje?",
  want_to_delete_report: "obrisati izvješće i sve stavke izvješća?",
  support_tasks: "Zadaci",
  "support-tasks": "Zadaci",
  "task-title": "Tekst zadatka",
  customers: "Kupci",
  databases: "Baze",
  support_time_logs: "Vrijeme rada",
  support_absences: "Izostanci",
  "add-support-absence": "Dodaj izostanak",
  "edit-support-absence": "Uredi izostanak",
  "no-support-absences": "Nema upisanih izostanaka",
  "support-absence-type-vacation": "Godišnji odmor",
  "support-absence-type-day-off": "Slobodan dan",
  "support-absence-type-sick-leave": "Bolovanje",
  "support-absence-type-trip": "Put",
  "support-absence-type-planned": "Planirano",
  "support-absence-type-other": "Ostalo",
  "support-absence-time-range": "Vrijeme u danu",
  "support-absence-time-from": "Od",
  "support-absence-time-to": "Do",
  "support-absence-has-note": "Ima napomenu",
  "support-absence-half-day": "Pola dana",
  "support-absence-half-day-period": "Dio dana",
  "support-absence-half-day-unspecified": "Nije određeno",
  "support-absence-morning": "Prijepodne",
  "support-absence-afternoon": "Poslijepodne",
  "all-users": "Svi korisnici",
  "all-types": "Sve vrste",
  "canned-responses": "Gotovi odgovori",
  "canned-response-add": "Dodavanje gotovog odgovora",
  "canned-response-edit": "Uređivanje gotovog odgovora",
  "canned-response-title": "Naziv",
  "canned-response-content": "Sadržaj",
  "insert-canned-response": "Umetni gotovi odgovor",
  "manage-canned-responses": "Upravljaj gotovim odgovorima",
  onixPhoneCompaniesOverview: "OnixPhone poduzeća",
  supportCompany: "Support poduzeće",
  activeUsers: "Aktivni korisnici",
  showOnlyWithoutSupportCompany: "Samo bez vezanog support poduzeća",
  noSupportCompany: "Nema vezanog support poduzeća",
  companiesCount: "Poduzeća: {{count}}",
  activeUsersCount: "Aktivnih korisnika: {{count}}",
  selectOnixPhoneCompany: "Poveži s OnixPhone poduzećem",
  linkOnixPhoneCompany: "Poveži",
  onixPhoneExternalId: "ExternalId za OnixPhone",
  currentLinkedOnixPhoneCompany: "Trenutno vezano OnixPhone poduzeće",
  previous: "Prethodna",
  "next-one": "Sljedeća",
  "marservis-work-orders": "Radni nalozi",
  "codebooks-customers": "Kupci",
  "adding-customer": "Dodavanje kupca",
  "editing-customer": "Uređivanje kupca",
  subject: "Subjekt",
  subjectId: "Subjekt",
  "work-order-items": "Stavke radnog naloga",
  "adding-work-order": "Dodavanje radnog naloga",
  "editing-work-order": "Uređivanje radnog naloga",
  projectId: "Projekt",
  "adding-work-order-item": "Dodavanje stavke radnog naloga",
  "editing-work-order-item": "Uređivanje stavke radnog naloga",
  "adding-work-order-item-work": "Dodavanje odrađenog posla",
  "editing-work-order-item-work": "Uređivanje odrađenog posla",
  "work-order-item-work": "Odrađeni poslovi",
  cause: "Uzrok",
  remedy: "Popravak",
  connectionSettings: "Postavke za spajanje",
  myEInvoiceSettings: "Moj e-račun",
  "Travel warrant sent to pantheon":
    "Putni nalog poslan je već poslan u Pantheon",
  projects: "Projekti",
  countryId: "Država",
  contactName: "Kontakt",
  mail: "E-mail",
  longName: "Dugi naziv",
  phone: "Telefon",
  vatidPrefix: "Porezni broj",
  vatid: "OIB",
  shortName: "Naziv",
  "done-hours": "Sati",
  sync_resource_CompanySettings: "Podaci poduzeća",
  sync_resource_THeCostDrv: "Nositelji troška",
  sync_resource_THeFa: "Osnovna sredstva",
  sync_resource_THeSetCountry: "Države",
  sync_resource_THeSetCurrency: "Valute",
  sync_resource_THeSetFxRateQuery: "Tečajna lista",
  sync_resource_THeSetSubj: "Subjekti",
  sync_resource_THePrsn: "Podaci personalne mape",
  sync_resource_THrSetDocTypeTrvlExp: "Tipovi putnih troškova",
  sync_resource_THrSetTrvlKm: "Cijena kilometra u periodu",
  is_paying_customer: "Paušalni kupac",
  showContactEntry: "Prikaži unos kontakta",
  authorizations: "Ovlaštenja",
  printDocumentTitleOverride: "Naslov dokumenta za ispis",
  printing: "Printanje",
  baseResources: "Osnovna sredstva",
  subjectSearch: "Pretraživanje kupaca",
  documentType: "Vrsta dokumenta",
  mobileWorkOrders: "Mobilni radni nalozi",
  documentTypePairs: "Parovi dokumenata",
  bluetoothPrinter: "Bluetooth printer",
  serialNumbers: "Serijski brojevi",
  adminSettings: "Administrativne postavke",
  dateFilterType: "Zadana vrijednost za filter datuma",
  appendToItemIfExists:
    "Kod skeniranja stavke, ako već postoji stavka s istom šifrom, dodaj količinu na postojeću stavku",
  copyOnlyLeftOverQuantity: "Kopiraj samo količinu koja je preostala",
  showAcDoc1: "Prikaži unos dokumenta 1",
  showAcDoc2: "Prikaži unos dokumenta 2",
  showAdDate: "Prikaži unos datuma dokumenta",
  showAdDateDoc1: "Prikaži unos datuma dokumenta 1",
  showAdDateDoc2: "Prikaži unos datuma dokumenta 2",
  ifCopyingFromOrderUpdateLeftOverQuantity:
    "Kod kopiranja iz narudžbe, ažuriraj količinu koja je preostala",
  documentLinkType: "Vrsta veze dokumenta",
  makeDocumentLinks: "Kreiraj vezu dokumenta",
  hideClerkFieldOnPrint: 'Sakrij polje "referent" na ispisu',
  clerkFieldOnPrint: 'Tekst umjesto "referent" na ispisu',
  hideAcceptedByFieldOnPrint: 'Sakrij polje "preuzeo" na ispisu',
  acceptedByFieldOnPrint: 'Tekst umjesto "preuzeo" na ispisu',
  hidePayMethodOnPrint: 'Sakrij polje "način plaćanja" na ispisu',
  hideDataForPaymentOnPrint: 'Sakrij polje "podaci za plaćanje" na ispisu',
  showAcDoc1OnPrint: 'Prikaži polje "dokument 1" na ispisu',
  showAdDateDoc1OnPrint: 'Prikaži polje "datum dokumenta 1" na ispisu',
  showAcDoc2OnPrint: 'Prikaži polje "dokument 2" na ispisu',
  showAdDateDoc2OnPrint: 'Prikaži polje "datum dokumenta 2" na ispisu',
  hideCurrencyDateOnPrint: 'Sakrij polje "datum valute" na ispisu',
  hideVATRecapitulationOnPrint: "Sakrij rekapitulaciju poreza na ispisu",
  alwaysUpdatePriceAndRebateFromClient:
    "Uvijek ažuriraj cijenu i rabate, bez obzira na to da li ih korisnik može unositi",
  defaultQuantity: "Zadana količina",
  transferAcDoc1WhenCopying: 'Kod kopiranja, prenesi polje "dokument 1"',
  transferAdDateDoc1WhenCopying:
    'Kod kopiranja, prenesi polje "datum dokumenta 1"',
  transferAcDoc2WhenCopying: 'Kod kopiranja, prenesi polje "dokument 2"',
  transferAdDateDoc2WhenCopying:
    'Kod kopiranja, prenesi polje "datum dokumenta 2"',
  showAcIdentOnPrint: 'Prikaži polje "acIdent" na ispisu',
  sendDocumentPDFToContactUsingCompanyOutboundEmail:
    "Pošalji PDF dokumenta kontaktu putem odlaznog e-maila poduzeća",
  allowManualVerifyFromDocumentOverview:
    "Omogući ručno potvrđivanje iz pregleda dokumenata",
  showContactEmailEntry: "Prikaži unos e-maila kontakta",
  storeContactEmailArbitraryInField:
    "Pohrani e-mail kontakta u proizvoljno polje s nazivom",
  fillReferentLineWithUserOnPrint:
    'Popuni polje "referent" na ispisu sa korisnikom',
  treatIdentAsBarcode: "Tretiraj ident kao barkod",
  classifsWhichDontRequireScanningForPicking:
    "Klasifikacije koje ne zahtijevaju skeniranje za direktni unos količine",
  classifs2WhichDontRequireScanningForPicking:
    "Klasifikacije 2 koje ne zahtijevaju skeniranje za direktni unos količine",
  acSetOfsWhichDontRequireScanningForPicking:
    "Knjigovodstvene vrste koje ne zahtijevaju skeniranje za direktni unos količine",
  "search-ticket-messages-by-content":
    "Pretraživanje poruka tiketa po sadržaju",
  contactCompanyCompanyId: "Poduzeće",
  userId: "Korisnik",
  temporaryOwnerId: "Agent",
  ticketCreatedOnFrom: "Datum kreiranja tiketa od",
  ticketCreatedOnTo: "Datum kreiranja tiketa do",
  messageCreatedOnFrom: "Datum kreiranja poruke od",
  messageCreatedOnTo: "Datum kreiranja poruke do",
  contactCompanyContactId: "Kontakt",
  "start-search": "Pretraži",
  copyingFromAnotherIsAShadowCopy:
    "Kopiranje iz drugog dokumenta je kopija sjenke (stavke se samo provjeravaju, ne kopiraju)",
  changeSourceDocumentStatusTo: "Promijeni status izvornog dokumenta u",
  sqlForm: "SQL forma",
  preparedness: "Spremnost",
  needsMoveAcPhoneUIDColumn: "Treba THe_Move acPhoneUID stupac",
  needsOrderAcPhoneUIDColumn: "Treba THe_Order acPhoneUID stupac",
  needsMoveItemTable: "Treba _tOP_MoveItem tablicu",
  needsMoveSignatureColumn: "Treba THe_Move _onixPhoneAcSignature stupac",
  needsFilesTable: "Treba _tOP_Files tablicu",
  needsFilesAcKeyColumn: "Treba _tOP_Files AcKey stupac",
  needsFilesFileCategoryColumn: "Treba _tOP_Files FileCategory stupac",
  needsFilesFileNameColumn: "Treba _tOP_Files FileName stupac",
  needsDocsAcPictureColumn: "Treba THe_Docs _acPicture stupac",
  needsPdfImageDocType: "Treba tHE_SetTypeDocu acTypeDocu podatak",
  needsPdfImageReplacementDocType: "Treba tHE_SetTypeDocu acTypeDocu podatak",
  needsOrderOldStatusColumn: "Treba THe_Order _OnixPhoneOldStatus stupac",
  allowSelectingMultipleDocumentsToCreateFrom:
    "Omogući odabir više dokumenata za kreiranje",
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments:
    "Sumiraj količinu za istog identa kod kreiranja iz više dokumenata",
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments:
    "Vizualno sumiraj količinu za istog identa kod kreiranja iz više dokumenata",
  adding: "Dodavanje",
  editing: "Uređivanje",
  "acSetOfAres-F": "3. Forme",
  "acSetOfAres-M": "4. SQLovi",
  "acSetOfAres-P": "1. Projekti",
  "acSetOfAres-U": "2. Uniti",
  "acSetOfAres-B": "5. VBScript",
  "acSetOfAres-J": "6. JScript",
  "acSetOfAres-D": "7. Import/export",
  "acSetOfAres-R": "8. Reports",
  "ares-sql-editor": "Ares/SQL editor",
  pascal: "Pascal",
  sql: "SQL",
  sqlexport2: "SQL export 2",
  form: "Forma",
  unit: "Unit",
  delphi: "Delphi",
  pantheonConnectionString: "Pantheon connection string",
  run: "Pokreni",
  run_on_all_databases: "Pokreni na svim bazama",
  run_on_all_companies: "Pokreni na svim poduzećima",
  sql_tab_default_name: "Skripta",
  sql_tab_add: "Nova kartica skripte",
  sql_tab_close: "Zatvori karticu",
  sql_tab_rename_hint: "Preimenuj karticu (dvoklik)",
  sql_tab_rename_prompt: "Naziv kartice",
  sql_tab_close_confirm: "Zatvoriti ovu karticu skripte? Njezin SQL tekst bit će obrisan.",
  run_on_all_companies_description:
    "Uključeno: Pokreni radi na svim poduzećima, a Pokreni na svim bazama radi na svim poduzećima i svim bazama njihovih servera (s preskakanjem već izvršenih server/baza).",
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2:
    "Ako barkod ima upisanu količinu pakiranja, koristi je umjesto AnUmToUm2 (kolete)",
  arbitraryFieldLocation: "Lokacija proizvoljnog polja",
  order: "Redoslijed",
  hideLeftOverQuantityOnPicking:
    "Sakrij preostalu količinu na dokumentima kod pickinga",
  syncPackagingWhenAddingNewItem:
    "Sinkroniziraj pakiranje kod dodavanja novog artikla",
  documentOnCreateMakeA4Print: "Ispiši novi dokument na A4 printer",
  forwarding_emails: "Proslijeđivanje emailova",
  add_forwarding_email: "Dodavanje proslijeđivanje emaila",
  edit_forwarding_email: "Uređivanje proslijeđivanje emaila",
  context: "Kontekst",
  receivingEmail: "Email primatelja",
  cc: "CC",
  bcc: "BCC",
  titleFormat: "Format naslova",
  bodyFormat: "Format tijela",
  documentFilterSQL: "SQL filter dokumenta",
  documentItemsFilterSQL: "SQL filter stavki dokumenta",
  duplicate: "Dupliciraj",
  caches: "Predmemorije",

  isDisabledElementDescription:
    "Deaktivirano - da li se VD uopće prikazuje korisniku",
  adminAllowChangingItemPriceElementDescription:
    "Dopusti promijenu cijene - da li na formi za unos stavke smije mijenjati cijenu",
  syncPackagingWhenAddingNewItemElementDescription:
    "Sinkroniziraj pakiranje kod dodavanja novog artikla - da li je kvačica na koleti (uskladi količinu) označena na unosu stavke",
  hideLeftOverQuantityOnPickingElementDescription:
    "Sakrij preostalu količinu na dokumentima kod pickinga - da li se na dokumentima prikazuje preostala količina (ovo je picking na standardnoj formi za unos, ne na onoj posebnoj formi pickinga žutoj)",
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2ElementDescription:
    'Ako barkod ima upisanu količinu pakiranja - koristi je umjesto AnUmToUm2 (kolete), imamo ares za barkodove i GS1, na šiframa subjekta na šifarniku idenata nastane novo polje "Količina u pakiranju", to je naše polje i ako je količina upisana koristiti će se u aplikaciji umjesto kolete',
  adminDeleteItemsAfterDocumentIsSavedElementDescription:
    "Omogući brisanje stavaka nakon spremanja - na listi dokumenata klikom na stavku otvori se confirm dialog za brisanje, ako je ovo uključeno, onda se briše, ako nije, onda se ne može brisati",
  adminItemQuantityMustBeInStockElementDescription:
    "Količina ne smije bit veća od dostupne - ovo se tiče validacije, ako je uključeno, na stavci se ne može upisati količina koja je veća od dostupne",
  adminUseAnWsPriceElementDescription:
    "Koristi AnWsPrice prije ostalih - ovo je jedna od cijena na artiklu, ako je uključeno, onda se ta cijena koristi prije ostalih, ovo treba gledati u Pantheon koja cijena bi trebala biti za artikl",
  adminShowDailyIncomeElementDescription:
    "Prikaži zaključak blagajne - dodaje novu ikonu u meni",
  adminShowSubjectAddElementDescription:
    "Prikaži dodavanje subjekata - dodaje novu ikonu u meni",
  mustFiscalizeElementDescription: "",
  recommendToMakeCodebooksOfflineElementDescription:
    'Prikaži OFFLINE preuzimanje šifarnika - kod nekih šifarnika prikazati da nema stavaka i da se može preuzeti šifarnik ili klikom na "nema stavaka" gumb onda pretražuje online',
  isRetailElementDescription:
    "Maloprodaja - da li se cijene unose sa PDV-om i ostalim vrstama poreza ili bez",
  documentTopAdditionalTextElementDescription:
    "Dodatni tekst na vrhu POS dokumenta - ovo je za unit test, da li se prikazuje dodatni tekst na vrhu termalnog ispisa",
  ignoreQuantityInWholeDocumentElementDescription:
    "Ignoriraj svu količinu u cijelom dokumentu - ne prikazuje se količina niti se ne može unijeti",
  adminSerialNumbersAreNotAutomatedElementDescription:
    "Ručno izdavanje serijskih brojeva - forsiraj ručno upisivanje serijskih brojeva, inače ide prema postavci na artiklu, da li ima vođenje SB",
  serialNumberDirectionIsInputElementDescription:
    "Serijski brojevi se UNOSE - ovo ide po VD ali može se i ovdje postaviti, da li se SB unose ili odabiru za izlaz",
  bluetoothPrintCopiesNumberElementDescription:
    'Broj kopija - koliko kopija se ispisuje, za svaki "ispis" ili prikaz ako se odabere "ispis na ekran" trebalo bi se ispisati toliko kopija, prije svakog sljedećeg ispisa kopije pita za nastavak ispisivanja',
  defaultQuantityElementDescription:
    'Zadana količina - količina koja se automatski upiše na novoj stavci pod količina. Zgodno je testirati uz "Ignoriraj svu količinu u cijelom dokumentu" jer je tu i obavezna',
  articleSearchShowOnlyInStockElementDescription:
    "Prikaži samo dostupno (Pretraživanje artikala) - da li se u šifarniku idenata za odabir vide samo dostupni artikli",
  articleSearchShowOnlyWhereAcFieldsAIsElementDescription:
    "Prikaži artikle tamo gdje je AcFieldsA - u šifarniku idenata se vide samo identi s AcFieldsA = 'to što je upisano'",
  articleSearchAllowSearchingByClassificationElementDescription:
    "Prikaži filter po klasifikaciji prije liste idenata - u šifarniku idenata se prikazuje filter po klasifikaciji, ako je tablet ili uključen tablet način onda su lijevo klasifikacije a desno identi za te klasifikacije",
  quantityDecimalPlacesElementDescription:
    "Decimalna mjesta količine - na koliko se dec mjesta zaokružuje, može se testirati na polju forme za unos stavke",
  articleSearchShowOnlyWhereAcSetOfItemIsElementDescription:
    "Prikaži samo gdje je AcSetOfItem - kao i za AcFieldsA, ali za AcSetOfItem na identu",
  useSquareArticlePickerElementDescription:
    "Koristi kvadratni izbornik artikala - da li je šifarnik idenata u kvadratnom obliku ili u obliku liste",
  itemListShowDetailedElementDescription:
    "Prikaži više detalja - da li se na listi stavki prikazuju još neki detalji to ćemo pogledati u kodu",
  adminEmphasizeInStockElementDescription:
    "Istakni artikle koji su na skladištu - standardno su istaknuti artikli koji su na skladištu, ako je ugašeno istaknuti su artikli koji nisu na skladištu, to je crveni okvir oko dostupne količine na OP u šifarniku idenata",
  jumpToEditAfterScanningItemWithBarcodeElementDescription:
    "Idi na uređivanje nakon skeniranja artikla sa barkodom - da li se korisnika baca na uređivanje stavke nakon skeniranja barkoda",
  treatIdentAsBarcodeElementDescription:
    "Tretiraj ident kao barkod - da li se ident može naći i skeniranjem barkoda koji sadrži ident, ne samo šifru subjekta",
  classifsWhichDontRequireScanningForPickingElementDescription:
    "Klasifikacije koje ne zahtijevaju skeniranje za direktni unos količine - ovo se odnosi na onaj nestandardni picking koji koristi posebnu formu za picking, da li se količina može direktno upisati ili se mora skenirati. Ovo je napravljeno zbog usluga, za njih se nema što skenirati a treba ih unijeti",
  classifs2WhichDontRequireScanningForPickingElementDescription:
    "Klasifikacije 2 koje ne zahtijevaju skeniranje za direktni unos količine - ovo je isto kao i prethodno, samo za drugu klasifikaciju",
  acSetOfsWhichDontRequireScanningForPickingElementDescription:
    "Knjigovodstvene vrste koje ne zahtijevaju skeniranje za direktni unos količine - ovo je isto kao i prethodno, samo za knjigovodstvene vrste",
  forceShowAvailableOnStockElementDescription:
    "U pregledu obavezno prikaži dostupno - da li se u pregledu artikala prikazuje dostupna količina ili sve",
  articleDontShowPriceAnyWhereElementDescription:
    "Ne prikazuj cijenu nigdje - da li se cijena vidi bilo gdje za tu VD, u pregledu dokumenata, na unosu stavke na pregledu dodanih stavki na totalima",
  articleDontShowStockAnyWhereElementDescription:
    "Ne prikazuj stanje na skladištu nigdje - da li se stanje na skladištu vidi bilo gdje za tu VD, u pregledu dokumenata, na unosu stavke na pregledu dodanih stavki na totalima",
  addingItemWarnIfQuantityMoreThanAvailableElementDescription:
    "Upozori ako je količina veća od dostupne - da li se upozorava korisnika ako se unese količina veća od dostupne",
  appendToItemIfExistsElementDescription:
    "Kod skeniranja stavke, ako već postoji stavka s istom šifrom, dodaj količinu na postojeću stavku - ako se ponovno skenira ident, da li se količina dodaje na postojeću stavku ili se kreira nova stavka na dokumentu",
  showAllItemsIgnoringWarehouseElementDescription:
    "Prikaži cijeli THe_SetItem (Pregled i pretraživanje, ako je skladište postaljveno i dalje će se stanje prikazivati samo za to skladište) - otprilike kako piše, i uglavnom zbog usluga jer one ne moraju biti zaprimljene na skladište a postoje u the_setitem pa ako se u šifarniku idenata vide samo identi na the_stock onda fale usluge, uglavnom, da li se vide identi koji nisu u the_stock u pregledu i pretraživanju idenata",
  stockViewShowOnlyInStockElementDescription:
    "Prikaži samo dostupno (Pregled skladišta) - da li se u pregledu skladišta vide samo dostupni artikli",
  adminDefaultAcPriceRateElementDescription:
    'Zadani AcPriceRate - otprilike kao "Koristi AnWsPrice prije ostalih", jedno i drugo se koristi, ali ovo je fleksibilnije tu se može postaviti bilo koja cijena od onih na the_setitem',
  hideWarehouseOverviewElementDescription:
    "Sakrij pregled skladišta - da li se u meniju vidi pregled skladišta",
  documentOnCreateMakePDFElementDescription:
    "Napravi PDF dokument prilikom kreiranja - da li skoči pregled PDF-a nakon zaključivanja",
  documentOnCreateMakeA4PrintElementDescription:
    "Ispiši novi dokument na A4 printer - ovo bi trebalo testirati, ali ne znam još kako",
  documentOnCreateMakeBluetoothPrintElementDescription:
    "Ispiši novi dokument na Bluetooth printer - ovo bi trebalo testirati, ali ne znam još kako",
  showDeliveryDeadlineDaysElementDescription:
    "Prikaži unos za rok isporuke - da li na glavi dokumenta postoji numerički popup za unos dana do roka isporuke",
  showDeliveryMethodElementDescription:
    "Prikaži unos načina isporuke - da li na glavi dokumenta postoji dropdown za odabir načina isporuke",
  showModifierCharacterPickerElementDescription:
    "Prikaži odabir dodatnog filtera prije učitavanja stavaka izvornog dokumenta",
  modifierCharacterLabelElementDescription:
    "Naziv koji se prikazuje u odabiru dodatnog filtera",
  showPaymentMethodElementDescription:
    "Prikaži unos načina plaćanja - da li na glavi dokumenta postoji dropdown za odabir načina plaćanja",
  showAcDoc1ElementDescription:
    "Prikaži unos dokumenta 1 - da li na glavi dokumenta postoji unos za dokument 1",
  showAdDateDoc1ElementDescription:
    "Prikaži unos datuma dokumenta 1 - da li na glavi dokumenta postoji unos za datum dokumenta 1, ako postoji i dokument 1 onda će se spojiti u jedno polje, inače je polje za sebe",
  showAcDoc2ElementDescription:
    "Prikaži unos dokumenta 2 - da li na glavi dokumenta postoji unos za dokument 2",
  showAdDateDoc2ElementDescription:
    "Prikaži unos datuma dokumenta 2 - da li na glavi dokumenta postoji unos za datum dokumenta 2, ako postoji i dokument 2 onda će se spojiti u jedno polje, inače je polje za sebe",
  showContactEntryElementDescription:
    "Prikaži unos kontakta - da li na glavi dokumenta postoji unos za kontakt",
  showContactEmailEntryElementDescription:
    "Prikaži unos e-maila kontakta - da li na glavi dokumenta postoji unos za e-mail kontakta",
  requireASignatureElementDescription:
    "Obavezno potpisivanje dokumenta - da li se dokument mora potpisati prije zaključivanja, skoči pregled PDF-a i potpisivanje",
  reverseItemsListElementDescription:
    "Obrnuti redoslijed stavki (zgodno kod inventura i ostalog gdje se skenira) - da li se stavke dodaju od dna prema vrhu na pregledu stavaka",
  createElementDescription: "Izrađivanje - da li se može kreirati dokument",
  readElementDescription: "Čitanje - da li se može vidjeti dokument",
  updateElementDescription: "Ažuriranje - da li se može ažurirati dokument",
  deleteElementDescription:
    "Brisanje - da li se može brisati dokument, ima neke veze s ili gazi onu postavku za brisanje stavke, to ćemo pogledati",
  disallowChangingCustomerElementDescription:
    "Onemogući promjenu kupca - da li se može mijenjati kupac",
  disallowPickingCustomerElementDescription:
    "Onemogući odabir kupca - da li se može odabrati kupac",
  defaultToThisCustomerElementDescription:
    'Zadani kupac - zgodno kad je kupac onemogućen, ali uvijek se može postaviti pa se preskače odabir kupca, razlika je s "Onemogući promjenu kupca" da li se može mijenjati kupac nakon što je postavljen ručno ili s ovom postavkom',
  defaultPaymentMethodElementDescription:
    'Zadani način plaćanja - koji način plaćanja će se popuniti na dokumentu, odgovara "Prikaži unos načina plaćanja" na dokumentu',
  defaultSubjectDaysForPaymentOnAddElementDescription:
    "Kod dodavanja subjekta zadani rok plaćanja - ako je postavljeno, novi subjekt dobiva taj broj dana; ako nije postavljeno, ostaje postojeće ponašanje",
  defaultSubjectPaymentMethodOnAddElementDescription:
    "Kod dodavanja subjekta zadani način plaćanja - ako je postavljeno, novi subjekt dobiva taj način plaćanja; ako nije postavljeno, ostaje postojeće ponašanje",
  adminIgnoreRebate1ElementDescription:
    "Ne koristi rabat 1 - da li se prikazuje unos za rabat 1 na novoj stavci",
  adminIgnoreRebate2ElementDescription:
    "Ne koristi rabat 2 - da li se prikazuje unos za rabat 2 na novoj stavci",
  adminIgnoreRebate3ElementDescription:
    "Ne koristi rabat 3 - da li se prikazuje unos za rabat 3 na novoj stavci",
  copyOnlyLeftOverQuantityElementDescription:
    "Kopiraj samo količinu koja je preostala - kod kopiranja iz dokumenta, stavke dokumenta koji se izrađuje će imati samo preostalu količinu, ne svu količinu, ovo je upisano na stavkama dokumenta koji se kopira, nešto kao anDispQty, naći ćemo",
  copyingFromAnotherIsAShadowCopyElementDescription:
    'Kopiranje iz drugog dokumenta je kopija sjenke (stavke se samo provjeravaju, ne kopiraju) - ovo je picking sa standardnom formom, stavke izvornog dokumenta se "kopiraju", ali ne mogu se uređivati niti su stvarno stavke na novom dokumentu, one se koriste samo kao vodilja kod skeniranja ili dodavanja stavki tako da znamo što smo trebali skenirati ili dodati',
  ifCopyingFromOrderUpdateLeftOverQuantityElementDescription:
    'Kod kopiranja iz narudžbe, ažuriraj količinu koja je preostala - da li se količina na izvornom dokumentu ažurira nakon što kreiramo dokument iz tog izvornog dokumenta, ovo zapravo ažurira istu količinu iz postavke "Kopiraj samo količinu koja je preostala"',
  changeSourceDocumentStatusToElementDescription:
    "Promijeni status izvornog dokumenta u - da li se postavlja status dokumenta na taj status nakon što se kreirao novi dokument iz njega",
  allowSelectingMultipleDocumentsToCreateFromElementDescription:
    "Omogući odabir više dokumenata za kreiranje - može se odabrati više dokumenata kada biramo dokument iz kojeg ćemo kreirati novi dokument, to je jedna forma sa kvačicama za odabir",
  accumulateQuantityOnDocumentWhenMultipleSourceDocumentsElementDescription:
    'Sumiraj količinu za istog identa kod kreiranja iz više dokumenata - sliči na postavku "Kod skeniranja stavke, ako već postoji stavka s istom šifrom, dodaj količinu na postojeću stavku", ali kod pripreme stavaka za novi dokument iz izvornog dokumenta, ovako isti ident ima samo jednu stavku na novom dokumentu, a ne više njih',
  documentLinkTypeElementDescription:
    "Vrsta veze dokumenta - što će se upisati u vezu dokumenta kod kreiranja novog dokumenta iz izvornog dokumenta",
  makeDocumentLinksElementDescription:
    "Kreiraj vezu dokumenta - da li se uopće radi veza dokumenta kod kreiranja novog dokumenta iz izvornog dokumenta",
  skipConfirmationOnShortcutsElementDescription:
    "Skoči direktno na izradu krajnjeg dokumenta (umjesto prikaza detalja izvornog dokumenta) - da li će se kod izbora izvornog dokumenta prvo prikazati detalji tog dokumenta ili idemo direktno na kreiranje novog dokumenta, jedan korak manje",
  transferAcDoc1WhenCopyingElementDescription:
    'Kod kopiranja, prenesi polje "dokument 1" - da li se na novi dokument prenosi polje "dokument 1" iz izvornog dokumenta',
  transferAdDateDoc1WhenCopyingElementDescription:
    'Kod kopiranja, prenesi polje "datum dokumenta 1" - da li se na novi dokument prenosi polje "datum dokumenta 1" iz izvornog dokumenta',
  transferAcDoc2WhenCopyingElementDescription:
    'Kod kopiranja, prenesi polje "dokument 2" - da li se na novi dokument prenosi polje "dokument 2" iz izvornog dokumenta',
  transferAdDateDoc2WhenCopyingElementDescription:
    'Kod kopiranja, prenesi polje "datum dokumenta 2" - da li se na novi dokument prenosi polje "datum dokumenta 2" iz izvornog dokumenta',
  alwaysUpdatePriceAndRebateFromClientElementDescription:
    "Uvijek ažuriraj cijenu i rabate, bez obzira na to da li ih korisnik može unositi - zanemari što korisnik unosi na stavci, ne bi smio niti moću unositi, i pusti Pantheonu da sve izračuna",
  allowManualVerifyFromDocumentOverviewElementDescription:
    "Omogući ručno potvrđivanje iz pregleda dokumenata - ovo je jedna opcija u meniju na pregledu dokumenata, testirati samo da li se prikazuje, ne radi još ništa",
  filterByAcDeliveryElementDescription:
    "Prikaži filter po AcDelivery (ovo se odnosi na AcDelivery postavljen na korisniku)",
  filterByAcVerifiedPricesElementDescription:
    "Filtriraj po AcVerifiedPrices - pregled dokumenata i pregled dokumenata za odabir izvornog dokumenta se filtrira po ovoj postavci",
  filterByAcVerifyStatusElementDescription:
    "Filtriraj po AcVerifyStatus - pregled dokumenata i pregled dokumenata za odabir izvornog dokumenta se filtrira po ovoj postavci",
  filterByAcDeptElementDescription:
    "Filtriraj po AcDept - pregled dokumenata i pregled dokumenata za odabir izvornog dokumenta se filtrira po ovoj postavci",
  showAcDeptMobileFilterOnDocumentListElementDescription:
    "Prikaži AcDept filter na listi dokumenata - prikazuje se filter po odjelu na pregledu dokumenata i pregledu dokumenata za odabir izvornog dokumenta",
  showAcDeliveryMobileFilterOnDocumentListElementDescription:
    "Prikaži AcDelivery filter na listi dokumenata - prikazuje se filter po dostavi na pregledu dokumenata i pregledu dokumenata za odabir izvornog dokumenta",
  useDeadlineDateOnOverviewElementDescription:
    "Prikaži rok za isporuku na pregledu dokumenata - prikazuje se filter za rok za isporuku na pregledu dokumenata i pregledu dokumenata za odabir izvornog dokumenta",
  dateFilterTypeElementDescription:
    "Zadana vrijednost za filter datuma - da li je i za koji period zadana vrijednost za filter datuma na pregledu dokumenata i pregledu dokumenata za odabir izvornog dokumenta",
  groupAllDocumentTypesAtThisPointElementDescription:
    "Grupiraj sve tipove dokumenata na ovom mjestu (ovo znači da će sve VD iz kojih se radi ovaj dokument biti grupirane u jedan pregled, jedan odabir ako je kopiranje i slično) - kako piše, npr možemo napraviti račun iz 5 VD narudžbi i onda nemamo pet kartica nego jednu za izradu računa ali kad pita za izvorni dokument onda se tu prikazuju dokumenti od svih tih 5 VD narudžbi",
  acStatusInElementDescription:
    "Prikaži samo dokumente s AcStatus - prikazuje samo dokumente koji imaju ovaj status u pregledu i odabiru izvornog dokumenta",
  showAllDocumentsNotOnlyAnUserInsElementDescription:
    "Prikaži sve dokumente, ne samo ona koja su kreirana od strane prijavljenog korisnika - na dokument se obično dodaje odgovorna osoba ili referent prema onoj postavci pantheonAnUserId i ova postavka kaže da li se prikazuju svi dokumenti ili samo oni koji su kreirani od strane prijavljenog korisnika s tim ID-jem",
  historyViewIgnoredFiltersElementDescription:
    "Filteri koje ignoriramo u povijesnom pregledu (npr: filterByAcDelivery,filterByAcDept) - ovo je jedna glupost koja je nastala kada sam dodao ove gornje filtere. Aplikacija ne zna da li si na pregledu dokumenata ili na odabiru izvornog dokumenta a u oba slučaja koristi postavke od ove VD, ali na pregledu želiš jedne filtere na odabiru izvornog dokumenta druge, ovo je jedan način da se to riješi, da se ovdje navedu filteri koje ne želimo koristiti na pregledu napravljenih dokumenata (povijesnih...)",
  hideDocumentElementsElementDescription:
    "Sakrij elemente dokumenta - lista elemenata koje sakrivamo, ovo može biti bilo gdje i bilo što na glavi dokumenta, sve je u aplikaciji pa ćemo pogledati",
  hideDocumentItemElementsElementDescription:
    "Sakrij elemente stavke - lista elemenata koje sakrivamo, ovo može biti bilo gdje i bilo što na stavci dokumenta, dodavanju stavke, sve je u aplikaciji pa ćemo pogledati",
  filterByAcTypeElementDescription:
    "Filtriraj po AcType - pregled osnovnih sredstava se filtrira po ovoj postavci",
  printTicketNameOverrideElementDescription:
    "Koji ispis koristiti za POS printer - ovo je postavka s kojom biramo koji će se ispis koristiti za POS printer, ako je prazna onda se koristi zadani ispis za tu vrstu dokumenta, ovo je kad netko traži baš svoj ispis",
  printDocumentTitleOverrideElementDescription:
    "Naslov dokumenta za ispis - naslov na PDF-u ili termalnom printeru, inače ide po nazivu VD iz Pantheona, ovako se može ručno postaviti na nešto drugo",
  subjectSearchElementDescription:
    "Filtriraj primatelje po AcFieldSa - filtrira primatelje po ovoj postavci",
  filterReceiversByAcFieldSaElementDescription:
    "Naziv polja u koje se upisuje pozicija u skladištu - na the_setitem se u ovo polje upisuje pozicija u skladištu iliti polica, ovo se može vidjeti i unjeti u pregledu skladišta u OP",
  warehousePositionTHeSetItemFieldNameElementDescription: "",
  warehouseShowPricesElementDescription:
    'Prikaži cijene na skladištu - prikazuje cijene na pregledu skladišta, slično kao "Ne prikazuj cijenu nigdje", ali samo za skladište, neki ne žele tu vidjeti cijene jer pregledu skladišta cijene neće biti točne, npr. zato što mora biti odabran kupac da bi se prema vrsti kupca/ugovorenom cijenu i ostalome cijene formirale, to nije moguće na pregledu skladišta',
  documentNoteElementDescription:
    "Naziv za ovu vrstu dokumenta (ono što se prikazuje u meniju i u naslovima) - kako piše, na kartici u meniju bi se ovo trebalo prikazati umjesto standardnog broja VD i njegovog Pantheon naziva",
  hideWorkOrderReceptionElementDescription:
    "Sakrij prijem - skrivanje taba prijem na mobilnom radnom nalogu",
  hideWorkOrderSpecicationsElementDescription:
    "Sakrij specifikaciju - skrivanje taba specifikacija na mobilnom radnom nalogu",
  hideWorkOrderServicesElementDescription:
    "Sakrij usluge - skrivanje taba usluge na mobilnom radnom nalogu",
  hideWorkOrderMaterialsElementDescription:
    "Sakrij materijale - skrivanje taba materijali na mobilnom radnom nalogu",
  hideWorkOrderReclamationsElementDescription:
    "Sakrij reklamacije - skrivanje taba reklamacije na mobilnom radnom nalogu",
  hideWorkOrderImagesElementDescription:
    "Sakrij slike - skrivanje taba slike na mobilnom radnom nalogu",
  hideWorkOrderPlaceFromToElementDescription:
    "Sakrij mjesto od/do - skrivanje taba mjesto od/do na mobilnom radnom nalogu",
  workOrderSpecificationTimeNotRequiredElementDescription:
    "Vrijeme specifikacije nije obavezno - na unosu specifikacije, ako je ovo postavljeno na da, onda se neće tražiti vrijeme prije spremanja specifikacije",
  workOrderSpecificationPrefillTimeElementDescription:
    'Zamjenski materijal - ovaj materijal će zapravo biti na RN nakon spremanja ako materijala nema na skladištu, ovo se može testirati tako da se nakon dodavanja stavke s identom koji nije na skladištu klikne na gore desno "Osvježi radni nalog", onda će u listi stavaka ovaj materijal stvarno dobiti tu šifru. Ako ovoga nema, ne bi se smijelo moći unijeti materijal koji nije na stanju',
  manualWorkOrderMaterialElementDescription: "",
  workOrderCanBeUnlockedElementDescription: "",
  acFieldSFLabelElementDescription:
    "Labela za AcFieldSF proizvoljno polje (KOMPAKT koristi za ticket) - u principu ako je upisano, na RN će se vidjeti proizvoljno tekstualno polje i vrijednost će se kod spremanja upisati u to polje na RN, testirati se može tako da se vidi da li je nakon spremanja ostala vrijednost, i naravno samo ako je upisano",
  hideClerkFieldOnPrintElementDescription:
    'Sakrij polje "referent" na ispisu - ovo je polje na PDF-u, ako je postavljeno na da, onda se neće prikazivati',
  clerkFieldOnPrintElementDescription:
    'Tekst umjesto "referent" na ispisu - neki baš žele da je odgovorna osoba ili nešto',
  hideAcceptedByFieldOnPrintElementDescription:
    'Sakrij polje "preuzeo" na ispisu - ovo je polje na PDF-u, ako je postavljeno na da, onda se neće prikazivati',
  acceptedByFieldOnPrintElementDescription:
    'Tekst umjesto "preuzeo" na ispisu - neki baš žele da je odgovorna osoba ili nešto',
  hidePayMethodOnPrintElementDescription:
    'Sakrij polje "način plaćanja" na ispisu - ovo je polje na PDF-u, ako je postavljeno na da, onda se neće prikazivati',
  hideDataForPaymentOnPrintElementDescription:
    'Sakrij polje "podaci za plaćanje" na ispisu - ovo je polje na PDF-u, ako je postavljeno na da, onda se neće prikazivati',
  hideCurrencyDateOnPrintElementDescription:
    'Sakrij polje "datum valute" na ispisu - ovo je polje na PDF-u, ako je postavljeno na da, onda se neće prikazivati',
  hideVATRecapitulationOnPrintElementDescription:
    "Sakrij rekapitulaciju poreza na ispisu - ovo je tablica dolje lijevo na PDF-u, ako je postavljeno na da, onda se neće prikazivati",
  showAcDoc1OnPrintElementDescription:
    'Prikaži polje "dokument 1" na ispisu - ovo je polje na PDF-u, ako je postavljeno na da, onda će se prikazivati',
  showAdDateDoc1OnPrintElementDescription:
    'Prikaži polje "datum dokumenta 1" na ispisu - ovo je polje na PDF-u, ako je postavljeno na da, onda će se prikazivati',
  showAcDoc2OnPrintElementDescription:
    'Prikaži polje "dokument 2" na ispisu - ovo je polje na PDF-u, ako je postavljeno na da, onda će se prikazivati',
  showAdDateDoc2OnPrintElementDescription:
    'Prikaži polje "datum dokumenta 2" na ispisu - ovo je polje na PDF-u, ako je postavljeno na da, onda će se prikazivati',
  showAcIdentOnPrintElementDescription:
    'Prikaži polje "acIdet" na ispisu - ovo je polje na PDF-u, ako je postavljeno na da, onda će se prikazivati (šifra identa, acIdent zapravo)',
  fillReferentLineWithUserOnPrintElementDescription:
    'Popuni polje "referent" na ispisu sa korisnikom - ovo je nasuprot polja za potpis ili s potpisom, ako je postavljeno na da, onda će se u polje referent upisati korisnik koji je spremao dokument iznad crte',
  label_definitions: "Predlošci ispisa naljepnica",
  manufacturer: "Proizvođač",
  manufacturerId: "Šifra",
  continuousOrSingleSheet: "Kontinuirani ili pojedinačni list",
  "Label-lHDistance":
    "(lHDist) Vodoravna udaljenost od lijevog ruba labele do lijevog ruba sljedeće labele",
  "Label-lVDistance":
    "(lVDist)Udaljenost od gornjeg ruba labele do gornjeg ruba sljedeće labele",
  "Label-lWidth": "(lWidth) Širina labele",
  "Label-lHeight": "(lHeight) Visina labele",
  "Label-lLeft": "(lLeft) Vodoravna udaljenost od lijevog ruba do prve labele",
  "Label-lUpper": "(lUpper) Udaljenost od gornjeg ruba do prve labele",
  "Label-nCols": "(nCols) Broj stupaca",
  "Label-nRows": "(nRows) Broj redaka",
  "Label-lPWidth": "(lPWidth) Širina papira",
  "Label-lPHeight": "(lPHeight) Visina papira",
  "QueryCase-Equals": "Jednako",
  "QueryCase-NotEquals": "Različito",
  "QueryCase-GreaterThan": "Veće od",
  "QueryCase-GreaterThanOrEqual": "Veće ili jednako",
  "QueryCase-LessThan": "Manje od",
  "QueryCase-LessThanOrEqual": "Manje ili jednako",
  "QueryCase-AnyOf": "Bilo koji od",
  "QueryCase-Truthy": "Istinito",
  "QueryCase-IsNull": "Je prazno (null)",
  "is-nominative": "Je",
  x_to: "Za",
  values: "Vrijednosti",
  label_definition_locations: "Lokacije predložaka ispisa naljepnica",
  labelDefinition: "Predložak ispisa naljepnice",
  labelDefinitionId: "Predložak ispisa",
  add_label_definition_location:
    "Dodavanje lokacije predloška ispisa naljepnice",
  edit_label_definition_location:
    "Uređivanje lokacije predloška ispisa naljepnice",
  LabelCompositions: "Sastav predloška ispisa naljepnice",
  AddingLabelComposition: "Dodavanje sastava predloška ispisa naljepnice",
  EditingLabelComposition: "Uređivanje sastava predloška ispisa naljepnice",
  "LabelDefinition-only-for-LabelComposition-preview":
    "(Predložak ispisa) samo za pregled",
  "LabelDefinitionLocation-only-for-LabelComposition-preview":
    "(Lokacija predloška ispisa) samo za pregled",
  addSVGTemplate: "Dodaj SVG predložak",
  pantheon_inis: "Pantheon INI ",
  pantheon: "Pantheon",
  company_id: "Šifra poduzeća",
  add_pantheon_ini: "Dodavanje Pantheon INI",
  edit_pantheon_ini: "Uređivanje Pantheon INI",
  connection_string_to_ini:
    "Poduzeće ima postavljene podatke za spajanje, ubaci ih u Pantheon INI",
  meshCentral: "MeshCentral",
  useMeshCentral: "Koristi MeshCentral",
  runPantheon: "Pokreni",
  setPantheon: "Postavi",
  onixDesktopPantheonExePath: "Exe folder",
  onixDesktopPantheonIniPath: "Ini folder",
  pantheon_version: "Verzija",
  pantheonVersionId: "Verzija Pantheona",
  openPantheonClicked: "Otvaram",
  downloadingPantheonExe: "Preuzimam exe",
  writingIni: "Preuzimam ini",
  executingPantheon: "Pokrenuto",
  extractingPantheonExe: "Otvaram .7z",
  movingExtractedPantheonExe: "Premještam exe",
  pantheon_version_group: "Grupa",
  comma: "Zarez",
  semicolon: "Točka-zarez",
  tab: "Tab",
  space: "Razmak",
  "HeaderOption.None": "Nema (generirati će se Column1-n)",
  "HeaderOption.FirstRow": "Prvi red je zaglavlje",
  "HeaderOption.Manual": "Ručno ću unijeti zaglavlje",
  "DelimiterEnum.comma": "Zarez (,)",
  "DelimiterEnum.semicolon": "Točka-zarez (;)",
  "DelimiterEnum.tab": "Tab (↹)",
  "DelimiterEnum.space": "Razmak ( )",
  "NewLineEnum.crlf": "Windows (CRLF)",
  "NewLineEnum.lf": "Unix (LF)",
  "NewLineEnum.cr": "Mac (CR)",
  pantheonSessionStarted: "Pokrenuta sesija",
  startingPantheonExe: "Pokrećem Pantheon",
  pantheonSessionFinished: "Sesija završena",
  pantheonSessionError: "Greška u sesiji",
  pantheonSessionTerminatedSuccessfully: "Uspješno završeno",
  pantheonSessionTerminatedWithError: "Greška",
  you_want_to_delete_pantheon_session: "obrisati ovu sesiju?",
  you_want_to_delete_all_pantheon_sessions: "obrisati sve sesije?",
  totalDuration: "Ukupno trajanje",
  agentId: "Agent",
  update_ini_from_local: "Ažuriraj INI",
  update_ini_from_local_description:
    "Sadržaj lokalnog INIja će se kopirati u ovaj INI",
  are_you_sure_you_want_to_update_ini_from_local: "Ažurirati INI?",
  update_ini_from_local_title: "Usporedba online i offline INIja",
  delete_exe_from_local: "Obriši lokalni exe",
  delete_exe_from_local_description:
    "Kada je npr. Pantheon pregazio exe sa svojom verzijom",
  onix_phone_user_tasks: "OnixPhone zadaci",
  ShowMessageToUser: "Prikaži poruku korisniku",
  UploadSQLiteDatabase: "Uploadaj SQLite bazu podataka",
  ExecuteSQLiteSQL: "Izvrši SQL na SQLite bazi podataka",
  taskData: "Podaci zadatka",
  task: "Zadatak",
  isCompleted: "Završen",
  nofityAdminOnCompletion: "Obavijesti admina o završetku",
  toAllUsers: "Svim korisnicima",
  workOrderPrintSpecificationDuration: "Ispiši specifikaciju radnog naloga",
  Maintenance: "Održavanje",
  Spam: "Spam",
  isMaintenance: "Automatski postavi e-mail ticket u status Održavanje",
  waitingForOffer: "Čeka na ponudu",
  isSpam: "Automatski postavi e-mail ticket u status Spam",
  "codebooks-time-log-templates": "Predlošci vremena rada",
  "codebooks-time-log-templates-add": "Dodavanje predloška vremena rada",
  "codebooks-time-log-templates-edit": "Uređivanje predloška vremena rada",
  templateName: "Naziv predloška",
  timeLogTemplate: "Predložak vremena rada",
  deliveryIsRequired: "Obavezna dostava",
  pantheon_license: "Licenca",
  license: "Licenca",
  allowSigningAfterDocumentIsSaved: "Omogući potpisivanje nakon spremanja",
  dontSaveIndividualPDFPages: "Ne spremaj pojedinačne PDF stranice",
  onlyShowSubjectsWhereLoggedInUserIsReferent:
    "Prikaži samo primatelje gdje je prijavljeni korisnik odgovorna osoba",
  TMNDocumentsDirect: "TMN Dokumentacija mobilno",
  TMNDocumentsWeb: "TMN Web dokumentacija",
  TMNDocumentsClassificationQueue: "TMN Klasifikacija dokumenata",
  TOpFilesForTMNDocuments: "TOpFiles",
  useFilteredOfflineCodebooks: "Koristi filtrirane offline šifrarnike",
  useDarkTheme: "Koristi tamnu temu",
  useListViewOnPickers: "Koristi listu umjesto grida na pickerima",
  useTabletMode: "Koristi tablet mod",
  useOnlyShortcuts: "Novi šareni izbornik",
  useDocumentTypeCodesInTitles: "Koristi kodove vrste dokumenata u naslovima",
  useWiderColumns: "Koristi šire mobilne stupce",
  featureFlag: "Feature flag",
  detailedLogging: "Detaljniji logging",
  mobileSettings: "Mobilne postavke",
  "email-settings-testing": "Email testiranje",
  host: "Poslužitelj",
  ports: "Portovi",
  port: "Port",
  success: "Uspjeh",
  forceTls: "Forsiraj TLS",
  tmnDocuments: "Dokumentacija",
  tmnAcDefaultSubject: "Zadani subjekt",
  tmnAnClassifIcationQid: "Klasifikacija",
  tmnAnMailBoxQid: "Poštanski sandučić",
  tmnAnStorageQid: "Spremište",
  showNumberOfUnlinkedDocuments: "Prikaži broj nepovezanih dokumenata",
  chatgpt: "Chat GPT",
  changeDocumentStatusAfterCreated:
    "Promijeni status dokumenta nakon kreiranja (acStatus na narudžbama, acVerifyStatus na ostalome)",
  changeDocumentPricesStatusAfterCreated:
    "Promijeni status cijena dokumenta nakon kreiranja (acVerifiedPrices na the_move)",
  billingSettingsLoadFailed: "Nije moguće učitati postavke naplate ticketa. Ponovno odaberite ticket.",
  offerNumber: "Broj ponude",
  legacyOfferWithoutNumber: "Ticket je ranije označen kao dio ponude bez broja. Spremite broj ponude ili prazno polje za uklanjanje oznake.",
  offerTypeDefault: "Vrijeme rada je dio ponude",
  nonBillableDefault: "Vrijeme rada nije naplativo",
  supportTimeLogsAlwaysNonBillable:
    "Vrijeme rada na podršci je uvijek nenaplativo",
  supportTimeLogRoundingMinutes:
    "Zaokruživanje vremena rada (minute, 0 = bez zaokruživanja)",
  generatePrintTimeOnCreate:
    "Generiraj vrijeme izdavanja na kreiranju ako je prazno",
  showProjectFeatures: "Prikaži kao projekt",
  projectPhase: "Faza projekta",
  showDepartmentAsReceiver: "Koristi odjel kao primatelja",
  showDepartmentOutAsReceiver: "Koristi odjel OUT kao primatelja",
  filterByUserOnAcIssuer: "Filtriraj po subjektu od korisnika po acIssuer",
  filterByUserOnAcReceiver: "Filtriraj po subjektu od korisnika po acReceiver",
  sortByReceiver: "Sortiraj po primatelju",
  defaultMoveDocumentSortField: "(MOVE) Zadano polje za sortiranje",
  defaultMoveDocumentSortAscending: "(MOVE) Zadano sortiraj rastuće",
  defaultOrderDocumentSortField: "(ORDER) Zadano polje za sortiranje",
  defaultOrderDocumentSortAscending: "(ORDER) Zadano sortiraj rastuće",
  alsoIncludeThisPantheonUserOfflineCodebooks:
    "Uključi i offline šifrarnike ovog Pantheon korisnika",
  addingArbitraryUserSetting: "Dodavanje proizvoljne postavke",
  editingArbitraryUserSetting: "Uređivanje proizvoljne postavke",
  transferToTicket: "Prebaci na ticket",
  "link-related-ticket": "Odaberi povezani ticket",
  "link-branch": "Poveži ticket",
  "related-branches": "Povezani ticketi",
  "branch-parents": "Nadređeni povezani ticketi",
  "branch-owner": "Vlasnik: {{owner}}",
  "branch-temp-owner": "Privremeni: {{owner}}",
  "branch-depth": "Razina {{depth}}",
  "branch-updated": "Ažurirano {{time}}",
  "branch-cycle-detected": "Ticket #{{ticketId}} je već prikazan u ovom lancu povezanih ticketa.",
  "open-ticket": "Otvori ticket",
  linked: "Povezano",
  transferUnfinishedTasksToTicket: "Prebaci nedovršene zadatke na ticket",
  GeneralOpenTasks: "Otvoreni zadaci",
  GeneralOpenTickets: "Otvoreni ticketi",
  MyOpenTickets: "Moji otvoreni ticketi",
  MyOpenTasks: "Moji otvoreni zadaci",
  phoneNumbers: "Brojevi telefona",
  skipGS1BarcodeCheck: "Preskoči GS1 provjeru barkodova kod skeniranja",
  "adding-wiki-entry": "Dodavanje novog članka",
  "editing-wiki-entry": "Uređivanje članka",
  "open-preview": "Otvori pregled",
  tags: "Tagovi",
  "no-tags": "Nema tagova",
  "wiki-entry-admin": "Članci",
  "wiki-entry-overview": "Pregled članaka",
  "wiki-entry-tags-admin": "Tagovi članaka",
  "wiki-entry-tags-add": "Dodavanje taga članka",
  "wiki-entry-tags-edit": "Uređivanje taga članka",
  "delete-wiki-entry-confirm":
    "Jeste li sigurni da želite obrisati ovaj članak?",
  "wiki-entry-categories": "Wiki kategorije",
  "wiki-entry-categories-admin": "Kategorije članaka",
  "wiki-entry-categories-add": "Dodavanje kategorije članka",
  "wiki-entry-categories-edit": "Uređivanje kategorije članka",
  "wiki-entry-tags": "Wiki tagovi",
  category: "Kategorija",
  existingInventoryCheckDays:
    "Broj dana unazad za provjeru idenata na nekoj inventuri",
  shouldHaveIBackup: "Trebao bi imati IBackup",
  isIBackup: "Je IBackup no-reply",
  "ibackup-entries": "IBackup logovi",
  "ibackup-computers": "IBackup računala",
  "sql-backup-overview": "SQL backup – pregled",
  "adding-ibackup-computer": "Dodavanje IBackup računala",
  "editing-ibackup-computer": "Uređivanje IBackup računala",
  transferEnteredItemQuantityToSerialNumber:
    "Prebaci količinu stavke na serijski broj",
  showPackageQuantityEntryField: "Prikaži polje za unos količine pakiranja",
  prioritisePackageQuantityEntryField:
    "Prioritiziraj polje za unos količine pakiranja",
  disallowChangingItemQuantityOnSerialInput:
    "Zabrani promjenu količine kod unosa serijskog broja",
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField:
    "Ubaci preostalu količinu od kopije sjenke u polje količine",
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber:
    "Popuni novi serijski broj sa zadnjim unesenim serijskim brojem za isti ident",
  useKeyboardBarcodeScanner: "Koristi tipkovnicu kao barkod skener",
  showCustomerName2AsPrimaryOnHeader:
    "Prikaži naziv 2 kupca kao primarni na zaglavlju",
  showCustomerOverview: "Prikaži pregled kupaca",
  allowSavingGeodecodedLocation: "Omogući spremanje geodekodirane lokacije",
  AllOptions: "Sve opcije",
  SelectedOptions: "Odabrane opcije",
  ThisUser: "Ovaj korisnik",
  AllUsers: "Svi korisnici",
  SelectedUsers: "Odabrani korisnici",
  AllTypes: "Svi tipovi",
  SameType: "Isti tip",
  SelectedTypes: "Odabrani tipovi",
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent:
    "Koristi količinu barkoda samo ako je prepoznata ista mjerna jedinica kao ident",
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments:
    "Zabrani kreiranje dokumenta za subjekt s dospjelim dugovanjima",
  hideNoteInNonHistoricalView: "Sakrij napomenu u ne povijesnom prikazu",
  customerCodeIsGenerated: "Kod dodavanja subjekata generiraj šifru",
  customerCodeAllowedKeys:
    "Dopuštene šifre povezane tablice za generiranje subjektove šifre",
  customerCodeFromAcSkis:
    "Povezana tablica za generiranje subjektove šifre je SKIS",
  completeDeliveryStatus: "Status izvornog dokumenta nakon završene dostave",
  partialDeliveryStatus: "Status izvornog dokumenta nakon djelomične dostave",
  sendLeftoverShadowsWithZero: "Pošalji preostale sjenke sa nulom",
  highlightArticlePickerTextOnNextOpen:
    "Označi tekst u pickeru artikala pri sljedećem otvaranju",
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint:
    "Umjesto acIdenta pokušaj prikazati šifru primatelja na ispisu",
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint:
    "Umjesto acName identa pokušaj prikazati acName šifre primatelja na ispisu",
  showItemAnNetWeightOnPrint: "Prikaži neto težinu artikla na ispisu",
  showItemAcCustomsTariffOnPrint: "Prikaži carinsku tarifu artikla na ispisu",
  showQuantityPerUnitOfMeasureOnPrint:
    "Prikaži količinu po mjernoj jedinici na ispisu",
  showItalianLabelsOnPrint: "Prikaži talijanske labele na ispisu",
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint:
    "Prikaži dokument 1 od stavki povezanih s tipom ItemDocLinkType na ispisu stavke",
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint:
    "Prikaži acKey i acDoc1 DATE od dokumenata povezanih s ovim tipom u zaglavlju na ispisu",
  showQuantityTotalOnPrint: "Prikaži ukupnu količinu na ispisu",
  middleSignatureTextOnPrint: "Tekst ispod srednjeg potpisa na ispisu",
  useVerySmallMobileInterface: "Koristi jako malo sučelje na mobitelu",
  interface: "Sučelje",
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument:
    "Prikaži kao kritičnu grešku ako artikl ne postoji na izvornom dokumentu",
  permanentLoginToken: "Token za trajnu prijavu",
  "print-permanent-token-PDF": "Ispis PDF-a trajnih tokena",
  showAcDeliveryOnDocumentList: "Prikaži AcDelivery na listi dokumenata",
  makeSerialStockCheck: "Provjeri zalihu serijskih brojeva prije spremanja",
  whenAddingSubjectSetAnClerkToCurrentUser:
    "Kod dodavanja subjekta postavi referenta na trenutnog korisnika",
  defaultSubjectDaysForPaymentOnAdd:
    "Kod dodavanja subjekta zadani rok plaćanja",
  defaultSubjectPaymentMethodOnAdd:
    "Kod dodavanja subjekta zadani način plaćanja",
  articleSearchShowOnlyWhereAcClassifIsIn:
    "Prikaži samo artikle gdje je AcClassif jedan od",
  technicalNote: "Tehnička napomena",
  allowDMSConfirmation: "Dopusti potvrđivanje DMS dokumenata",
  initiallyShowOnlyUnconfirmedDMSDocuments:
    "Inicijalno prikaži samo nepotvrđene DMS dokumente",
  showOnlyDMSDocumentsAssignedToMe:
    "Prikaži samo DMS dokumente koji su meni dodijeljeni (anUserId)",
  articleSearchShowOnlyWhereAcFieldsAIs:
    "Prikaži artikle tamo gdje je AcFieldsA",
  articleSearchShowOnlyWhereAcFieldsBIs:
    "Prikaži artikle tamo gdje je AcFieldsB",
  articleSearchShowOnlyWhereAcFieldsCIs:
    "Prikaži artikle tamo gdje je AcFieldsC",
  articleSearchShowOnlyWhereAcFieldsDIs:
    "Prikaži artikle tamo gdje je AcFieldsD",
  articleSearchShowOnlyWhereAcFieldsEIs:
    "Prikaži artikle tamo gdje je AcFieldsE",
  articleSearchShowOnlyWhereAcFieldsFIs:
    "Prikaži artikle tamo gdje je AcFieldsF",
  articleSearchShowOnlyWhereAcFieldsGIs:
    "Prikaži artikle tamo gdje je AcFieldsG",
  articleSearchShowOnlyWhereAcFieldsHIs:
    "Prikaži artikle tamo gdje je AcFieldsH",
  articleSearchShowOnlyWhereAcFieldsIIs:
    "Prikaži artikle tamo gdje je AcFieldsI",
  articleSearchShowOnlyWhereAcFieldsJIs:
    "Prikaži artikle tamo gdje je AcFieldsJ",

  articleSearchShowOnlyWhereAnFieldnAIs:
    "Prikaži artikle tamo gdje je AnFieldnA",
  articleSearchShowOnlyWhereAnFieldnBIs:
    "Prikaži artikle tamo gdje je AnFieldnB",
  articleSearchShowOnlyWhereAnFieldnCIs:
    "Prikaži artikle tamo gdje je AnFieldnC",
  articleSearchShowOnlyWhereAnFieldnDIs:
    "Prikaži artikle tamo gdje je AnFieldnD",
  articleSearchShowOnlyWhereAnFieldnEIs:
    "Prikaži artikle tamo gdje je AnFieldnE",
  articleSearchShowOnlyWhereAnFieldnFIs:
    "Prikaži artikle tamo gdje je AnFieldnF",
  articleSearchShowOnlyWhereAnFieldnGIs:
    "Prikaži artikle tamo gdje je AnFieldnG",
  articleSearchShowOnlyWhereAnFieldnHIs:
    "Prikaži artikle tamo gdje je AnFieldnH",
  articleSearchShowOnlyWhereAnFieldnIIs:
    "Prikaži artikle tamo gdje je AnFieldnI",
  articleSearchShowOnlyWhereAnFieldnJIs:
    "Prikaži artikle tamo gdje je AnFieldnJ",

  articleSearchShowOnlyWhereAdFielddAIs:
    "Prikaži artikle tamo gdje je AdFielddA",
  articleSearchShowOnlyWhereAdFielddBIs:
    "Prikaži artikle tamo gdje je AdFielddB",
  articleSearchShowOnlyWhereAdFielddCIs:
    "Prikaži artikle tamo gdje je AdFielddC",
  articleSearchShowOnlyWhereAdFielddDIs:
    "Prikaži artikle tamo gdje je AdFielddD",

  textArbitraryFieldsFilters: "Filter po tekstualnim proizvoljnim poljima",
  numericArbitraryFieldsFilters: "Filter po numeričkim proizvoljnim poljima",
  dateArbitraryFieldsFilters: "Filter po datumnim proizvoljnim poljima",

  showLineNoteOnPrint: "Prikaži napomene stavaka na ispisu",
  thermalPrintCompanyNameFontSize:
    "Veličina fonta za naziv poduzeća na termalnom ispisu",
  thermalPrintShowCompanyImage: "Prikaži sliku poduzeća na termalnom ispisu",
  showOnlyArticlesWithCustomerContractPrice:
    "Prikaži samo artikle s ugovorenim cijenama kupca",
  thermalPrintCompanyNameFontSizeWidth:
    "Širina fonta za naziv poduzeća na termalnom ispisu",
  thermalPrintCompanyNameFontSizeHeight:
    "Visina fonta za naziv poduzeća na termalnom ispisu",
  acStatus: "Status",
  defaultCustomerType: "Zadana vrsta kupca",
  defaultCustomerTypeFilter: "Zadani filter vrste kupca",
  WaitingForOffer: "Čeka na ponudu",
  linkToTicketCopied: "Link na ticket kopiran",
  copyOnlyThoseWithLeftOverQuantity0:
    "Kopiraj samo one kojima količina nije već unesena",
  "show-file-viewer": "Prikaži preglednik datoteka",
  "picking-attachmentElementDescription": "Privici",
  travel_to: "Putovanje u",
  "enter-finalization-period": "Unos perioda",
  showArticlesGroupedByCodeButSeparate:
    "Prikaži stavke grupirane po šifri ali odvojene u pozadini",
  "Travel warrant already sent to pantheon":
    "Putni nalog je već poslan u Pantheon",
  "Travel warrant does not exist": "Putni nalog ne postoji",
  connectionName: "Naziv veze",
  applicationPackets: "Aplikacijski paketi",
  tenant: "Klijent",
  travel_warrants_overview: "Pregled",
  "travel-warrants2": "Putni nalozi",
  travel_warrants_overview_title: "Pregled putnih naloga",
  AllUsersExceptSelected: "Svi korisnici osim odabranih",
  doNotFilterDailyRecapByUserId: "Ne filtriraj dnevni pregled po korisniku",
  fiscalizations: "Fiskalizacije",
  fiscalize_manually: "Fiskaliziraj ručno",
  TMNAcDefaultStatus: "Zadani status",
  tmnAcDefaultStatus: "Zadani status",
  dmsAcStatusIn: "Filter po statusima (odvojeno zarezom bez razmaka)",
  travel_warrants_overview_calculations: "Pregled obračuna",
  disableUsingShadowItemAsItemBase:
    "Onemogući korištenje sjenke kao osnovne stavke",
  showLastNOrdersForCustomer: "Prikaži zadnjih N narudžbi za kupca",
  close_lock: "Zaključi",
  travel: "Putovanje",
  "pantheon-document-number": "Pantheon dokument",
  "web-document-number": "Web dokument",
  "no-pantheon-id": "Ne postoji Pantheon dokument",
  migratedToNewServer: "Migriran na novi server",
  validFrom: "Važi od",
  validTo: "Važi do",
  campaignId: "Šifra kampanje",
  description_and_technical_note: "Opis i tehnička napomena",
  "total-billable-time-tracked": "Ukupno naplativo vrijeme",
  "total-time-to-billable-time-difference": "Razlika",
  "time-and-billable-time": "Vrijeme i naplativo vrijeme",
  "created-ticket-on-date": "Datum kreiranja ticketa",
  expand: "Proširi",
  collapse: "Skupi",
  "new-sql-query": "Novi SQL upit",
  "company-connection-string-required":
    "Potrebno je postaviti connection string za poduzeće!",
  "add-as-technical-note": "Dodaj kao tehničku napomenu",
  "Travel warrant already closed in pantheon":
    "Putni nalog je već zatvoren u Pantheonu",
  "otvori dokument": "Otvori dokument",
  "No data": "Nema podataka",
  "pick a document": "Odaberite dokument",
  "Please wait": "Molimo pričekajte",
  Loading: "Učitavanje",
  clientServers: "On-Premise poslužitelji",
  serverName: "Ime poslužitelja",
  serverIP: "IP adresa",
  workHoursCheckError: "Zadnja greška provjere rada unutar radnog vremena",
  pingTime: "Zadnji ping",
  selectClientServer: "Odaberite On-Premise poslužitelj",
  workingHours: "Radno vrijeme",
  addWorkingHours: "Dodavanje radnog vremena",
  editWorkingHours: "Uređivanje radnog vremena",
  addDefaultClientServerWeek: "Dodaj 08:00 - 20:00 za sve dane",
  confirmDefaultClientServerWeek:
    "Dodati radno vrijeme 08:00 - 20:00 za svih sedam dana?",
  startTime: "Početak",
  endTime: "Kraj",
  Sunday: "Nedjelja",
  Monday: "Ponedjeljak",
  Tuesday: "Utorak",
  Wednesday: "Srijeda",
  Thursday: "Četvrtak",
  Friday: "Petak",
  Saturday: "Subota",
  showOnlyWOWhereCurrentUserSpecExists:
    "Prikaži samo RN gdje postoji specifikacija rada trenutnog korisnika",
  showWOWorkersEntry: "Prikaži unos radnika na RN",
  workOrderWorkerPickerIncludesInactiveWorkers:
    "U odabiru radnika za RN prikaži i neaktivne radnike",
  warehouseViewFixedAcSubject: "Zadano skladište na pregledu skladišta",
  tHrPrsnForOnlyOnixPhoneUsers:
    "Filter radnika (THr_Prsn) prikazuje samo OnixPhone korisnike",
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer:
    "Prikaži samo dokumente gdje je prijavljeni korisnik referent na acIssuer ili acReceiver subjektu",
  filterByCurrentUserIdIsAnSigner1:
    "Prikaži samo dokumente gdje je prijavljeni korisnik potpisnik 1.",
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader:
    "Slika poduzeća na PDF-ovima je širine cijele stranice i zamjenjuje zaglavlje",
  showSerialNumberSearchForWorkOrders:
    "Prikaži pretragu serijskih brojeva na radnim nalozima",
  showCostBearerOnWorkOrders: "Prikaži nositelja troška na radnim nalozima",
  showReceiverOnWorkOrders: "Prikaži primatelja na radnim nalozima",
  showBuyerOnWorkOrders: "Prikaži kupca na radnim nalozima",
  showInventoryNumberOnWorkOrders: "Prikaži inventarni broj na radnim nalozima",
  showAttachSSCCButton: "Prikaži gumb za dodavanje SSCC-a palete",
  "pantheon-upgrade-logs": "Zapisnici nadogradnje Pantheona",
  PantheonUpgrade: "Nadogradnja Pantheona",
  pantheonVersion: "Verzija Pantheona",
  logOverview: "Pregled zapisnika",
  companyCountAtVersion: "Broj poduzeća na verziji",
  customContractPriceFilter:
    "Koristi proceduru za određivanje kvačice za filter po ugovorenim cjenama",
  pdfSignWithoutGeneration: "Potpiši PDF bez generiranja",
  palletEntry: "Unos palete",
  adminForceAcPriceRate: "Uvijek koristi ovaj acPriceRate",
  "Travel warrant return note not set": "Izvještaj o povratku nije popunjen!",
  subjectFieldForSSCCRequirementCheck:
    "Polje subjekta za provjeru da li je obavezan SSCC",
  subjectFieldValueForSSCCRequirementCheck:
    "Vrijednost polja subjekta za provjeru da li je obavezan SSCC",
  companyEmailPDFCC: "CC email adresa poduzeća",
  companyEmailPDFBCC: "BCC email adresa poduzeća",
  companyEmailDefaultEmail: "Zadana email adresa poduzeća",
  showOnlyDocumentsWhereAnClerkIsCurrentUser:
    "Prikaži samo dokumente gdje je prijavljeni korisnik anClerk (odgovorni)",
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser:
    "Prikaži samo dokumente gdje je prijavljeni korisnik anNoteClerk (referent)",
  showAnClerkAndAnNoteClerkIsOROperation:
    "Koristi anClerk i anNoteClerk filter kao OR operaciju",
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel:
    "Labela za ispis acKey i acDoc1 iz povezanih dokumenata u zaglavlju",
  alwaysShowTheseAcSetOfItem:
    "Uvijek prikaži ove acSetOfItem (skladište i odabir artikala)",
  TravelWarrants2: "Putni nalozi 2 (Danieli)",
  WorkRecords2: "Evidencija rada 2 (Vrijeme rada - Pula Parking)",
  PantheonSubjectsSync: "Sinkronizacija Pantheon subjekata",
  packet: "Paket",
  responsibleUserId: "Odgovorni korisnik",
  accountingUserId: "Računovodstveni korisnik",
  alternativeUserId: "Alternativni korisnik",
  userAccessHash: "Interna šifra pristupa",
  pushedAppKey: "Aplikacijski ključ (Pushed)",
  pushedAppSecret: "Aplikacijska tajna (Pushed)",
  pushedTargetType: "Vrsta cilja (Pushed)",
  bookStackTokenId: "BookStack token ID",
  bookStackTokenSecret: "BookStack tajni token",
  teamViewerId: "TeamViewer ID",
  teamViewerSyncEnabled: "TeamViewer sinkronizacija uključena",
  bluetoothPrinterPrintSpeed: "Brzina ispisa Bluetooth printera",
  bluetoothPrinterAddress: "Adresa Bluetooth printera",
  bluetoothPrinterName: "Naziv Bluetooth printera",
  bluetoothPrinterBoldMode: "Podebljani ispis Bluetooth printera",
  bluetoothPrinterPaperWidth: "Širina papira Bluetooth printera",
  bluetoothPrinterType: "Vrsta Bluetooth printera",
  bluetoothPrinterArbitrarySettings: "Proizvoljne postavke Bluetooth printera",
  a4PrinterURL: "A4 printer URL",
  newPassword: "Nova lozinka",
  isDeleted: "Deaktiviran",
  pantheonAcRegNo: "Pantheon acRegNo",
  pantheonAcWorker: "Pantheon acWorker",
  pantheonAnUserId: "Pantheon anUserId",
  pantheonAcName: "Pantheon acName",
  pantheonAcUserId: "Pantheon acUserId",
  pantheonAcDelivery: "Pantheon dostava",
  pantheonSignature: "Pantheon potpis",
  pantheonPIN: "Pantheon OIB",
  encodedUserId: "Kodirani korisnički ID",
  acWorkerNapomena: "Napomena",
  work_start: "Početak rada",
  adDateDoc1PDFLabel: "AdDateDoc1 PDF labela",
  adDateDoc2PDFLabel: "AdDateDoc2 PDF labela",
  showDoc12AndTheirDatesOnDocumentList:
    "Prikaži Doc1 i Doc2 i njihove datume na listi dokumenata",
  headerClerkPDFLabel: "Labela za anClerk (referent) na PDF-u",
  adDateDoc1EntryIsTimeOnly: "AdDateDoc1 unos je samo vrijeme",
  adDateDoc2EntryIsTimeOnly: "AdDateDoc2 unos je samo vrijeme",
  invoice: "Račun",
  orderAcWarehouseIsCopiedToMoveAcIssuer:
    "Order AcWarehouse se kopira u AcIssuer na Move",
  orderAcWarehouseIsCopiedToMoveAcIssuerDescription:
    "Ovo zapravo kopira acWarehouse iz Order u Move na ono što je OnixPhone skladište, jer se to koristi i kao izlazno skladište",
  orderAcWarehouseIsCopiedToMoveAcReceiver:
    "Order AcWarehouse se kopira u AcReceiver na Move",
  orderAcWarehouseIsCopiedToMoveAcReceiverDescription:
    "Ovo zapravo kopira acWarehouse iz Order u Move na ono što je OnixPhone primatelj (customer) jer se to koristi i kao ulazno skladište",
  allowChangingWarehouse: "Dozvoli promjenu skladišta",
  allowChangingWarehouseDescription:
    "Omogućuje promjenu skladišta u zaglavlju novog dokumenta i kada je skladište već popunjeno.",
  filterOrdersByThisAcWarehouse: "Filtriraj narudžbe po ovom skladištu",
  filterMovesByThisAcIssuer: "Filtriraj Move po ovom AcIssuer",
  filterMovesByThisAcReceiver: "Filtriraj Move po ovom AcReceiver",
  acDocsOrderingOnPDF:
    "Redoslijed acDocs na PDF-u (odvojeno zarezom, što fali neće se ispisati)",
  UnfinishedProjects: "Nedovršeni projekti",
  EmergencyTickets: "Hitni ticketi",
  HighPriorityTickets: "Ticketi visokog prioriteta",
  OldTickets: "Stari ticketi",
  "high-priority": "VISOKO",
  "old-tickets-short": "STARO",
  "last-activity": "Zadnja aktivnost",
  UnfinishedTasks: "Nedovršeni zadaci",
  DelegatedToMe: "Delegirani na mene",
  WaitingFor: "Čeka drugoga",
  UnreadMessages: "Nepročitane poruke",
  UnfinishedTickets: "Nedovršeni ticketi",
  UnassignedTickets: "Nedodijeljeni ticketi",
  showAcDescrOnPDFs: "Prikaži AcDescr identa na PDF-ovima",
  pantheonCompanyImage: "Slika poduzeća (koristi se gore lijevo na PDF-ovima)",
  pantheonCompanyOnixPhoneSmallImage:
    "Slika poduzeća (koristi gore lijevo na početnoj OnixPhone)",
  allowGenericDocumentTypeImageAttachments:
    "Dopusti dodvanje slika na generičke vrste dokumenata (običan THe_Move, THe_order)",
  showCustomersAcName2OnThermalPrint:
    "Prikaži AcName2 kupca na termalnom ispisu",
  dmsListFilterOnDefaultClassification:
    "Filtriraj listu DMS dokumenata po zadanoj klasifikaciji",
  onlyCostBearerNoReceiverOrCustomerPickingAllowed:
    "Dozvoli biranje samo nositelja troška, i primatelja od kupca s nositelja troška",
  keepAdDateDoc1And2Unrounded: "Zadrži AdDateDoc1 i AdDateDoc2 ne zaokružene",
  fieldReference: "Proizvoljno polje",
  fieldType: "Vrsta polja",
  fieldRequired: "Obavezno polje",
  fieldBaseValue: "Zadana vrijednost polja",
  prefillFromField: "Polje iz izvornog dokumenta",
  "period-not-set": "Period nije postavljen",
  hideDMSMetadataEntryFields: "Sakrij polja za unos DMS metapodataka",
  "total-invoicing-time-tracked": "Ukupno vrijeme za fakturirati",
  showAllDMSDocumentsForURAClassifications:
    "Prikaži sve DMS dokumente za URA klasifikacije (klasifikacija like URA_%)",
  isMainAresDeploymentDatabase: "Glavna Ares baza podataka za implementaciju",
  isMainAresTestingDatabase: "Glavna Ares baza podataka za testiranje",
  lastAresTestRunPassed: "Zadnje testiranje prošlo",
  lastSuccessfulAresTestRunAt: "Vrijeme zadnjeg uspješnog testiranja",
  aresDeployments: "Ares implementacije",
  aresVersion: "Verzija",
  aresDeploymentGroupName: "Ares grupa",
  aresDeploymentGroupId: "Ares grupa",
  isGrunfSync: "Je grupa Aresa za sinkronizaciju s Grunfom",
  thermalPrinterPrintVerticalPDF417:
    "Ispiši PDF417 (HUB) vertikalno na termalnom ispisu",
  disallowManualWarehouseSearch: "Zabrani ručnu pretragu skladišta",
  hideWarehouseSupplier: "Sakrij dobavljače na skladištu",
  hideWarehouseItemActions: "Sakrij akcije artikala na skladištu",
  isDMSReferenceUser: "Je DMS referentni korisnik",
  teamviewer: "TeamViewer",
  areses: "Aresi",
  initializeOnixPhoneCompany: "Inicijaliziraj OnixPhone poduzeće",
  openMainDatabaseOverview: "Otvori pregled poduzeća na glavnom serveru",
  "company-ares-versions": "Ares verzije poduzeća",
  aresAcKey: "Ares acKey",
  currentVersion: "Trenutna verzija",
  isDMSReferenceUserElementDescription:
    "Korisnik koji se koristi kao predložak za DMS vrste dokumenta za nove korisnike (pokreće se iz grunfa, ovdje je samo označen, sve VD na ovom korisniku će se prebaciti)",
  excludeFromDmsBilling: "Ne naplaćuje se u DMS obračunu",
  excludeFromDmsBillingElementDescription:
    "Naš interni korisnik: njegovo OnixPhone DMS korištenje ne ulazi u Onix DMS obračun.",
  teamViewerSyncEnabledElementDescription:
    "Kad je isključeno, korisnik zadržava spremljeni TeamViewer ID, ali se TeamViewer sinkronizacija i vezanje sesija na tog korisnika neće pokretati.",
  allowDMSCRUDOnlyForUsersFiles:
    "Dopusti CRUD operacije samo na DMS datotekama prijavljenog korisnika",
  allowPullingDMSEInvoicesFromService:
    "Dopusti povlačenje DMS E-Računa iz servisa",
  allowDMSReclassification: "Dozvoli reklasifikaciju",
  aresGroups: "Ares grupe",
  accountingCompanyId: "Računovodstvo",
  linkedCompanySettingsId: "Povezani company settings",
  leadCompanies: "Vođena poduzeća",
  variableName: "Varijabla",
  variableType: "Vrsta varijable",
  "enum.InstallationVariableType.String": "Tekst",
  "enum.InstallationVariableType.Integer": "Cijeli broj",
  "enum.InstallationVariableType.Boolean": "Kvačica",
  "enum.InstallationVariableType.DateTime": "Datum i vrijeme",
  "enum.InstallationVariableType.Float": "Decimalni broj",
  Boolean: "Kvačica",
  String: "Tekst",
  Integer: "Cijeli broj",
  Float: "Decimalni broj",
  DateTime: "Datum i vrijeme",
  variableValue: "Vrijednost varijable",
  installationVariables: "Instalacijske varijable",
  "adding-installation-variable": "Dodavanje instalacijske varijable",
  Show: "Prikaži",
  Hide: "Sakrij",
  prepared_time_logs: "Pripremljeno vrijeme rada",
  resetsOnInvoicing: "Resetira se kod fakturiranja",
  aresGroup: "Ares grupa",
  installationStep: "Korak instalacije",
  dateAndTime: "Datum i vrijeme",
  operation_successful: "Operacija uspješna",
  isInvoicedToAccounting: "Fakturira se računovodstvu",
  invoicingSumType: "Agregacija kod fakturiranja",
  count: "Količina",
  durationSum: "Zbroj trajanja",
  Count: "Količina",
  DurationSum: "Zbroj trajanja",
  "enum.InstallationStepSumType.Count": "Količina",
  "enum.InstallationStepSumType.DurationSum": "Zbroj trajanja",
  alternateMainServerPrefix: "Alternativni prefiks poduzeća",
  alternateMainServerPrefixElementDescription:
    "Ako je postavljeno, koristi se ovaj prefiks umjesto prvih 3 slova naziva poduzeća za kreiranje korisnika na OnixPhone bazi.",
  cardPaymentProvider: "Provider kartičnog plaćanja",
  createThisAccountingCompanyCompanies:
    "Kreiraj poduzeća za ovo računovodstveno poduzeće",
  triggerType: "Vrsta okidača",
  "enum.DeploymentGroupStepTriggerType.OnInstall": "Prilikom instalacije",
  notOurCustomer: "Nije naš kupac",
  OutsideCompanies: "Vanjska poduzeća",
  "this-is-not-our-customer": "Nije naš kupac",
  saveUnsignedAsSignedPDF: "Spremaj nepotpisane kao potpisane PDF",
  isSQLExecutionAres: "Je Ares za SQL izvršavanje",
  isTestSuiteAres: "Je Ares testni paket",
  showDMSXMLItems: "Prikaži DMS XML stavke (dopusti uređivanje)",
  allowDMSXMLItemArticlePicking: "DMS XML: omogući odabir artikla",
  allowDMSXMLItemDepartmentPicking: "DMS XML: omogući odabir odjela",
  allowDMSXMLItemCostBearerPicking: "DMS XML: omogući odabir nositelja troška",
  subjectDocumentListDocumentType:
    "Vrsta Pantheon dokumenta za dokumente subjekta i povijest računa",
  isBoostrapExecutionAres: "Je Ares za Bootstrap izvršavanje",
  FirstWave: "1. Prvi val",
  SecondWave: "2. Drugi val",
  ThirdWave: "3. Treći val",
  FourthWave: "4. Četvrti val",
  FifthWave: "5. Peti val",
  SixthWave: "6. Šesti val",
  deleteDataInThisColumn: "obrisati podatke u ovom stupcu",
  "company-notes": "Bilješke",
  "comma-separated-tags": "Tagovi odvojeni zarezom",
  onixPhone: "OnixPhone",
  onixPhoneCompany: "OnixPhone poduzeće",
  externalId: "Vanjski ID",
  userCount: "Broj korisnika",
  usernames: "Korisnička imena",
  activityCheckSql: "SQL upit za provjeru aktivnosti",
  "new-messages-available": "Stigle su nove poruke",
  "viewing-now": "Trenutno gledaju",
  "ares-activity": "Aktivnost Ares grupe",
  "ares-activity-last-check": "Zadnja provjera aktivnosti",
  "ares-activity-result": "Rezultat provjere aktivnosti",
  aresActivityReport: "Ares izvještaj aktivnosti",
  onixClrUsageReport: "Onix CLR izvještaj korištenja",
  onixDmsBillingReport: "Onix DMS izvještaj za naplatu",
  onixPhoneFunctionalityActivityReport: "OnixPhone izvještaj aktivnosti funkcionalnosti",
  byCompanyAndUser: "Po poduzeću i korisniku",
  totalActivity: "Ukupno aktivnosti",
  companyGroup: "Poduzeće",
  accountingCompanyGroup: "Knjigovodstveno poduzeće",
  userGroup: "Korisnik",
  aresDeploymentGroup: "Ares grupa",
  "Select Ares implementation.": "Odaberite Ares implementaciju.",
  "Select database.": "Odaberite bazu.",
  "Select Ares group.": "Odaberite Ares grupu.",
  "Ares group installed for {{companyName}}.":
    "Ares grupa je instalirana za {{companyName}}.",
  "Create companies": "Kreiraj poduzeća",
  "Create companies ({{count}})": "Kreiraj poduzeća ({{count}})",
  "Companies were created!": "Poduzeća su kreirana!",
  "Install selected Ares group": "Instaliraj odabranu Ares grupu",
  "Install selected Ares group for new company":
    "Instaliraj odabranu Ares grupu za novo poduzeće",
  "New Ares group for new company": "Nova Ares grupa za novo poduzeće",
  "Install Ares group": "Instaliraj Ares grupu",
  "Installing Ares group...": "Instaliram Ares grupu...",
  "Ares implementations": "Ares implementacije",
  "Ares versions": "Verzije Aresa",
  "Loading versions...": "Učitavam verzije...",
  "Installation steps": "Instalacijski koraci",
  "On all databases": "Na svim bazama",
  "Update all Areses": "Ažuriraj sve Arese",
  "Search by database or company": "Pretraži po bazi ili poduzeću",
  "Search Ares group": "Pretraži Ares grupu",
  Environment: "Okruženje",
  "Select all": "Označi sve",
  "No payload provided.": "Zahtjev nije poslan.",
  "Database name is required.": "Naziv baze je obavezan.",
  "Accounting company not found.": "Računovodstveno poduzeće nije pronađeno.",
  "Accounting company Pantheon connection string is empty.":
    "Pantheon connection string računovodstvenog poduzeća je prazan.",
  "Selected Ares group does not belong to this accounting company.":
    "Odabrana Ares grupa ne pripada ovom računovodstvenom poduzeću.",
  "Ares group not found.": "Ares grupa nije pronađena.",
  "Ares group is required.": "Ares grupa je obavezna.",
  "Ares service is not configured.": "Ares servis nije konfiguriran.",
  "Ares installation is already in progress for this company.":
    "Ares instalacija je već u tijeku za ovo poduzeće.",
  "No companies found for the given accounting company.":
    "Nisu pronađena poduzeća za odabrano računovodstveno poduzeće.",
  firstSeen: "Prvi put viđeno",
  lastSeen: "Zadnji put viđeno",
  document_type_templates: "Predlošci vrsta dokumenata",
  source_document_type: "Izvorna vrsta dokumenta",
  select_document_type: "Odaberite dokument",
  partial_template: "Djelomični (partial)",
  fields_to_apply: "Polja koja će se primijeniti",
  field: "Polje",
  value_template: "Vrijednost",
  accountingCompany: "Knjigovodstveno poduzeće",
  zbirno: "Zbirno",
  zbirnoRacunovodstvo: "Zbirno računovodstvo",
  onixPhoneDmsUsage: "OnixPhone DMS korištenje",
  dmsPantheonUsage: "DMS Pantheon korištenje",
  pantheonDocumentCount: "Pantheon broj dokumenata",
  databaseCount: "Broj baza",
  sourceIssues: "Problemi izvora",
  message: "Poruka",
  generatedOn: "Generirano",
  isBackgroundInstallable: "Instalacija u pozadini",
  minPantheonBuildNo: "Min Pantheon build",
  maxPantheonBuildNo: "Max Pantheon build",
  pantheonBuildConstraintsInfoTitle: "Pantheon build ograničenja",
  pantheonBuildConstraintsInfo:
    "Koristi se zadnje 4 znamenke build broja (npr. 4600). Ostavite prazno da se grupa uvijek nudi.",
  activityCheckSqlHelpTitle: "Kako radi provjera aktivnosti",
  activityCheckSqlHelp:
    "Izvršava se nad Pantheon bazom poduzeća. Vrati 1 redak, 1 stupac; >0/true/neprazno => aktivno; 0/false/prazno/bez redaka => neaktivno.",
  exportToCSV: "Izvoz u CSV",
  exportToExcel: "Izvoz u Excel",
  connection: "Konekcija",
  sourceTable: "Izvorna tablica",
  counter: "Brojač",
  action: "Akcija",
  summary: "Sažetak",
  records: "zapisa",
  executionPhase: "Faza izvršavanja",
  executionPhaseOrder: "Redoslijed faze",
  Standard: "Standardno",
  Bootstrap: "Bootstrap",
  SqlExecution: "SQL izvršavanje",
  TestRefreshSetup: "Priprema osvježavanja testova",
  TestSuite: "Testni paket",
  TestTeardown: "Čišćenje nakon testova",
  allowModifyExistingDocuments: "Dopusti mijenjanje postojećih dokumenata",
  "not-reviewed": "Nije pregledano",
  "unit-of-measure": "Jedinica mjere",
  "adding-marservis-material": "Dodavanje materijala",
  "editing-marservis-material": "Uređivanje materijala",
  "add-material": "Dodaj materijal",
  "material-can-be-selected-once": "Materijal se može odabrati samo jednom.",
  "quantity-must-be-positive": "Količina mora biti veća od nule.",
  "onix_web_app": "Onix Web",
  "portal_tickets_tile": "Tiketi podrške",
  "portal_sign_in_title": "Prijava za korisnike podrške",
  "portal_sign_in_intro": "Pratite svoje tikete Onix podrške. Upišite adresu e-pošte s koje pišete podršci i poslat ćemo vam kod za prijavu.",
  "portal_sign_in_open": "Prijava za korisnike podrške (tiketi)",
  "portal_email": "E-pošta",
  "portal_email_invalid": "Upišite ispravnu adresu e-pošte.",
  "portal_send_code": "Pošalji kod",
  "portal_code": "Kod iz e-pošte",
  "portal_code_sent": "Ako je adresa ispravna, na {{email}} smo poslali šesteroznamenkasti kod. Vrijedi 10 minuta.",
  "portal_verify_code": "Prijavi se",
  "portal_other_email": "Druga adresa",
  "portal_consent_title": "Novi korisnički račun",
  "portal_consent_intro": "Za {{email}} još ne postoji račun. Račun služi samo za pregled vaših tiketa Onix podrške i možete ga obrisati u profilu.",
  "portal_consent_checkbox": "Pristajem na otvaranje računa i obradu moje adrese e-pošte i imena za prikaz tiketa.",
  "portal_create_account": "Otvori račun",
  "portal_sign_in_failed": "Prijava nije uspjela.",
  "team-viewer-script-token": "TeamViewer skriptni token",
  "team-viewer-script-token-description": "Token iz TeamViewer profila (Aplikacije). Treba pravo čitanja izvještaja o vezama, grupa i uređaja. Ne istječe pa se ne osvježava.",
  "team-viewer-script-token-saved": "TeamViewer token je spremljen.",
  "team-viewer-script-token-failed": "Spremanje TeamViewer tokena nije uspjelo.",
};
